import { useCallback, useEffect, useRef, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { InputFieldset } from "ui/inputFieldset";
import { SelectFieldset } from "ui/selectFieldset";
import { SelectTriggerUI } from "ui/selectTrigger";
import { PopoverTriggerUI } from "ui/popoverTrigger";
import { TextareaUI } from "ui/textareaUI";
import { Label } from "../../ui/label";
import { Badge } from "../../ui/badge";
import { Textarea } from "../../ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectValue,
} from "../../ui/select";
import { Checkbox } from "../../ui/checkbox";
import { Alert, AlertDescription } from "../../ui/alert";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
} from "../../components/ui/command";
import {
  CheckCircle2,
  XCircle,
  Upload,
  FileText,
  User,
  Building2,
  MapPin,
  AlertCircle,
  Plus,
  X,
  ShieldCheck,
  Trash2,
  Users,
  Check,
  ChevronDown,
  ChevronUp,
  History,
  ChevronsUpDown,
  Eye,
  Loader2,
} from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import { toast } from "sonner";
import { cn } from "../../ui/utils";
import {
  AddAreaOfOpertaion,
  AddNewPartners,
  approvePartner,
  ApprovedTourOperator,
  Country,
  deleteAreaOfOperation,
  deletePartners,
  getCountryCity,
  getRegistrationDetails,
  rejectTourOperator,
  rejectTourOperatorDocument,
  reUploadPartnersDocuments,
  reUploadTourDocuments,
  saveConfigurations,
  TourOperatorType,
} from "../../services/newRegistrationService";
import { FullScreenLoading } from "../../components/ui/loader";
import AddNewPartnerPopup from "./AddNewPartnerPopup";
import {
  AreaErrors,
  AreaOfOperation,
  ConfigErrors,
  DocumentHistory,
  DocumentHistoryNew,
  DocumentUpload,
  Partner,
  PartnerFormErrors,
  TORegistration,
  TourOperatorTypeObj,
} from "../../types/tourOperator";
import ConfirmDialog from "../../ui/ConfirmDialog";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import {
  formatFileSizeFromKB,
  formatUploadedDateTime,
  getFileViewUrl,
  removeFullSpecialCharacters,
  // removeSpecialCharacters,
  toSentenceCase,
  validatePhoneNumberInput,
} from "../../utils/commonutils";
import {
  DocumentApiResponse,
  getScreenDocuments,
} from "../../services/documentService";
import { useScreenPermission } from "../../hooks/useScreenPermission";
import { usePageHeader } from "contexts/PageHeaderContext";

interface PartnerConfiguration {
  partnerId: string;
  permissionDate: string;
  toType: string;
  isInclusive: boolean;
  permanentDiscount: string;
  isRequiredForPublic: boolean;
}

interface PartnerForm {
  id: string;
  isNonItsPartner: boolean;
  itsNumber: string;
  name: string;
  fullName: string;
  fatherName: string;
  email: string;
  mobileNumber: string;
  dateOfBirth: string;
  address: string;
  role: string;
  isPartner: boolean;
  isOfficeStaff: boolean;
  loginRequired: boolean;
  isAuthorizedGroupLeader: boolean;
  documents: DocumentUpload[];
  addedAfterApproval?: boolean;
  acceptedFormats?: string;
  maxFileSizeKB?: number;
}

interface AreaToDelete {
  areaId: string;
  tourOperatorId: string;
}

interface TORegistrationAdminPageProps {
  onNavigate?: (page: string) => void;
}

interface MisalDocumentUpload {
  id: string;
  name: string;
  file: File | null;
  isRequired: boolean;
  country?: string;
  acceptedFormatsList: string[]; // ✅ array of formats
  maxFileSizeKB?: number;
  maxFileSizeMB?: number;
  history?: DocumentHistory[];
  versions?: DocumentHistoryNew[];
  uploadedUrl?: string;
}

const toLocalDateInputValue = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const TORegistrationReviewPage = ({
  onNavigate,
}: TORegistrationAdminPageProps) => {
  const navigate = useNavigate();
  const { setPageHeader } = usePageHeader();
  const params = useParams<{ id: string }>();
  const [showApproveConfirm, setShowApproveConfirm] = useState(false);
  const [selectedRegistration, setSelectedRegistration] =
    useState<TORegistration | null>(null);
  const pendingPartnerApprovalCount =
    selectedRegistration?.pendingPartnerApprovalCount ?? 0;
  const normalizedBusinessType = selectedRegistration?.businessType
    ?.trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  const isSoleProprietor =
    normalizedBusinessType === "sole_proprietor" ||
    normalizedBusinessType === "sole_proprietorship";
  const [isAreaDeleteOpen, setIsAreaDeleteOpen] = useState(false);
  const [areaToDelete, setAreaToDelete] = useState<AreaToDelete | null>(null);
  const [AddpartnerErrors, setAddPartnerErrors] = useState<PartnerFormErrors>(
    {},
  );
  const [errors, setErrors] = useState<AreaErrors>({});
  const [activeTab] = useState<
    "pending" | "approved" | "rejected" | "Rejected"
  >("pending");
  const [rejectReason, setRejectReason] = useState("");
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [rejectedDoc, setRejectedDoc] = useState<DocumentUpload | null>(null);
  const [reUploadFiles, setReuploadFiles] = useState<File[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [refetchApi, setRefetchApi] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  // Check if current user is super admin

  const storedUser = localStorage.getItem("fhims_auth_user");
  const currentUser = storedUser ? JSON.parse(storedUser) : null;
  const isSuperAdmin = Boolean(currentUser?.isSuperAdmin);

  // Document history expansion state
  const [expandedDocHistory, setExpandedDocHistory] = useState<
    Record<string, boolean>
  >({});
  const [expandedMisalHistory, setExpandedMisalHistory] = useState(false);
  const [expandedPartnerDocHistory, setExpandedPartnerDocHistory] = useState<
    Record<string, boolean>
  >({});
  const [loading, setLoading] = useState(false);

  // Form states - ITS Data (all editable except ITS number)
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [arabicName, setArabicName] = useState("");
  const [gender, setGender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");

  // Additional Information
  const [whatsappUsername, setWhatsappUsername] = useState("");
  // const [passportNumber, setPassportNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [alternateMobile, setAlternateMobile] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [officeNumber, setOfficeNumber] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [otherCity, setOtherCity] = useState("");
  const [permanentAddress, setPermanentAddress] = useState("");
  const [areasOfOperation, setAreasOfOperation] = useState<AreaOfOperation[]>(
    [],
  );
  const [currentArea, setCurrentArea] = useState<AreaOfOperation>({
    id: "",
    country: "",
    city: "",
    otherCity: "",
    address: "",
    contactNumber: "",
    countryId: "",
    cityId: "",
    tourOperatorId: "",
    areaId: "",
  });
  const [isAuthorizedGroupLead, setIsAuthorizedGroupLead] = useState(false);
  const [documents, setDocuments] = useState<DocumentUpload[]>([]);
  const [countriesList, setCountriesList] = useState<Country[]>([]);
  const [TourOperatorList, setTourOperatorList] = useState<
    TourOperatorTypeObj[]
  >([]);

  // Admin Configuration Fields
  const [permissionDate, setPermissionDate] = useState("");
  const [toType, setToType] = useState("");
  const [isInclusive, setIsInclusive] = useState(false);
  const [permanentDiscount, setPermanentDiscount] = useState("");
  const [isRequiredForPublic, setIsRequiredForPublic] = useState(false);
  const [configErrors, setConfigErrors] = useState<ConfigErrors>({});
  const minimumPermissionDate = toLocalDateInputValue(new Date());

  const handlePermissionDateChange = (value: string) => {
    setPermissionDate(value);
    setConfigErrors((current) => ({
      ...current,
      permissionDate:
        value && value < minimumPermissionDate
          ? "Permission expiry date cannot be in the past"
          : undefined,
    }));
  };

  // Combobox open states
  const [countryComboOpen, setCountryComboOpen] = useState(false);
  const [areaCountryComboOpen, setAreaCountryComboOpen] = useState(false);
  const [areaCityComboOpen, setAreaCityComboOpen] = useState(false);

  // Partner-wise configuration
  const [partnerConfigurations, setPartnerConfigurations] = useState<
    PartnerConfiguration[]
  >([]);
  const [selectedPartnerForConfig, setSelectedPartnerForConfig] =
    useState<Partner | null>(null);

  // Document deletion
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState<string | null>(null);
  const [deleteRemark, setDeleteRemark] = useState("");

  // Partner editing state
  // const [editingPartner, setEditingPartner] = useState<Partner | null>(null);
  const [partners, setPartners] = useState<Partner[]>([]);
  // Partner removal
  const [isPartnerRemoveDialogOpen, setIsPartnerRemoveDialogOpen] =
    useState(false);
  const [partnerToRemove, setPartnerToRemove] = useState<Partner | null>(null);
  const [isPartnerApproveDialogOpen, setIsPartnerApproveDialogOpen] =
    useState(false);
  const [partnerToApprove, setPartnerToApprove] = useState<Partner | null>(
    null,
  );
  const [isApprovingMember, setIsApprovingMember] = useState(false);
  const [isPartnerDialogOpen, setIsPartnerDialogOpen] = useState(false);
  const [partnerFormData, setPartnerFormData] = useState<PartnerForm>({
    id: "",
    isNonItsPartner: false,
    itsNumber: "",
    name: "",
    fullName: "",
    fatherName: "",
    email: "",
    mobileNumber: "",
    dateOfBirth: "",
    address: "",
    role: "",
    isPartner: false,
    isOfficeStaff: false,
    loginRequired: false,
    isAuthorizedGroupLeader: false,
    documents: [],
    addedAfterApproval: false,
  });
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [misaldocuments, setMisalDocuments] = useState<MisalDocumentUpload[]>(
    [],
  );
  const [showMisalHistory, setShowMisalHistory] = useState<
    MisalDocumentUpload[]
  >([]);
  const selectedAreaCountry = countriesList.find(
    (c) => String(c.countryId) === currentArea.countryId,
  );
  const {
    canAdd,
    canEdit,
    canDelete,
    canApprove,
    icon: ScreenIcon,
  } = useScreenPermission();

  //  FETCH COUNTRY & CITY & DOCUMENT
  const fetchMisalDocuments = useCallback(
    async (screenName: string): Promise<MisalDocumentUpload[]> => {
      const response = await getScreenDocuments(screenName);
      if (!response) return [];
      return response.map((doc: DocumentApiResponse) => ({
        id: String(doc.documentId),
        name: doc.documentName,
        file: null,
        isRequired: doc.isMandatory,
        acceptedFormatsList: doc.acceptedFormatsList || [], // ✅ correct key
        maxFileSizeKB: doc?.maxFileSizeKB,
        maxFileSizeMB: doc?.maxFileSizeMB,
        history: [],
        versions: [],
      }));
    },
    [],
  );

  const fetchCountryCity = useCallback(async () => {
    try {
      const result = await getCountryCity();
      if (!result) {
        return;
      }
      setCountriesList(result);
    } catch (error) {
      console.error("Failed to load documents");
    }
  }, []);

  //  FETCH COUNTRY & CITY & DOCUMENT
  const fetchTourOperatorType = useCallback(async () => {
    try {
      const result = await TourOperatorType();
      if (!result) {
        return;
      }
      setTourOperatorList(result);
    } catch (error) {
      console.error("Failed to load tour operator type");
    }
  }, []);

  useEffect(() => {
    fetchCountryCity();
    fetchTourOperatorType();
    fetchMisalDocuments("TO_Registration_Approval").then((docs) => {
      setMisalDocuments(docs);
    });
  }, [fetchCountryCity, fetchTourOperatorType, fetchMisalDocuments]);

  const fetchRegistrationDetails = useCallback(async () => {
    if (!params?.id) return;
    try {
      setLoading(true);
      const res = await getRegistrationDetails(params?.id);
      if (!res) {
        toast.error("No registration details found");
        return;
      }
      setSelectedRegistration(res);
    } catch (error) {
      toast.error("Failed to fetch registration details");
    } finally {
      setLoading(false);
    }
  }, [params?.id]);

  useEffect(() => {
    setPageHeader({
      title: "Review Tour Operator Registration",
      icon: <ScreenIcon className="h-4 w-4" />,
      onBack: () => navigate("/registration/list"),
    });

    return () => setPageHeader(null);
  }, [navigate, ScreenIcon, setPageHeader]);

  useEffect(() => {
    fetchRegistrationDetails();
  }, [fetchRegistrationDetails, params?.id, refetchApi]);

  const handleMisalFileUpload = (docId: string, file: File | null) => {
    if (!file) return;

    const selectedDoc = misaldocuments.find((d) => d.id === docId);
    if (!selectedDoc) return;

    const fileExt = file.name.split(".").pop()?.toLowerCase();

    if (!fileExt || !selectedDoc.acceptedFormatsList.includes(fileExt)) {
      toast.error(
        `Invalid file format. Allowed: ${selectedDoc.acceptedFormatsList.join(", ")}`,
      );
      return;
    }

    const maxSizeBytes = (selectedDoc?.maxFileSizeKB ?? 0) * 1024;
    if (file.size > maxSizeBytes) {
      toast.error(
        `File size must be less than ${selectedDoc.maxFileSizeMB} MB`,
      );
      return;
    }

    setMisalDocuments(
      misaldocuments.map((doc) => (doc.id === docId ? { ...doc, file } : doc)),
    );
  };

  useEffect(() => {
    if (!selectedRegistration) return;
    const registration = selectedRegistration;
    setFirstName(registration.firstName);
    setMiddleName(registration.middleName);
    setLastName(registration.lastName);
    setArabicName(registration.arabicName);
    setGender(registration.gender === "male" ? "Male" : "Female");
    setDateOfBirth(registration.dateOfBirth.split("T")[0]);
    setWhatsappUsername(
      registration.whatsAppUsername || registration.whatsappUsername || "",
    );
    setRejectReason(
      registration.rejectReason ||
        registration.rejectedReason ||
        registration.remarks ||
        registration.remark ||
        "",
    );
    // setPassportNumber(registration.passportNumber  || "");
    // setMobileNumber(registration.mobile);
    setMobileNumber(registration.mobileNumber);
    setAlternateMobile(registration.alternateMobile || "");
    setOfficeName(registration.officeName);
    setOfficeNumber(registration.officeNumber);
    setCountry(String(registration.countryId));
    setCity(registration.cityId);
    setOtherCity(registration.otherCity || "");
    setPermanentAddress(registration.permanentAddress);
    setAreasOfOperation(registration.areasOfOperation);
    setIsAuthorizedGroupLead(
      registration.isAuthorizedGroupLeader ||
        registration.isAuthorizedGroupLead,
    );

    const mappedDocuments: DocumentUpload[] = selectedRegistration.documents
      ?.filter((doc) => doc.moduleCode === "TO_REG")
      ?.map((doc) => {
        const latestVersion = doc.versions?.[0];
        const allHistories =
          doc.versions?.flatMap((version) => version.histories || []) || [];
        return {
          id: String(doc.documentId ?? ""),
          documentMasterId: String(doc.documentMasterId ?? ""),
          name: doc.documentName ?? "",
          status: doc.status ?? "",
          isRequired: Boolean(doc.isMandatory),
          versions: doc.versions,
          uploadedUrl: latestVersion?.filePath ?? "",
          history: allHistories ?? [],
          file: null,
          acceptedFormats: doc?.acceptedFormats,
          maxFileSizeKB: doc?.maxFileSizeKB,
        };
      });
    setDocuments(mappedDocuments);

    const approvalDocs = selectedRegistration.documents
      .filter((doc) => doc.moduleCode === "TO_REG_APPROVAL")
      .map((doc) => {
        const latestVersion = doc.versions?.[doc.versions.length - 1];
        const allHistories =
          doc.versions?.flatMap((version) => version.histories || []) || [];
        return {
          id: String(doc.documentId ?? ""),
          name: doc.documentName ?? "",
          file: null,
          isRequired: Boolean(doc.isMandatory),
          uploadedUrl: latestVersion?.filePath ?? "",
          versions: doc.versions,
          history: allHistories,
          acceptedFormatsList: doc?.acceptedFormatsList || [], // ✅ FIX
        };
      });
    setShowMisalHistory(approvalDocs);

    const mappedPartners: Partner[] = registration.partners.map(
      (p: Partner): Partner => ({
        id: p.partnerId,
        itsNumber: p.itsNumber,
        name: p.name,
        fullName: p.fullName ?? p.name,
        fatherName: p.fatherName ?? "",
        email: p.email,
        mobileNumber: p.mobile ?? "",
        dateOfBirth: p.dateOfBirth ?? "",
        address: p.address ?? "",
        role: p.role,
        isMainOperator: p.isMainOperator,
        tourOperatorId: p.tourOperatorId,
        approvedStatus: p.approvedStatus,

        isPartner: p.role?.trim().toLowerCase() === "partner",
        isOfficeStaff: p.role?.trim().toLowerCase() === "office_staff",
        loginRequired: Boolean(p.loginRequired),
        isAuthorizedGroupLeader: Boolean(p.isAuthorizedGroupLeader),

        permissionExpireDate: p?.permissionExpireDate,
        tourOperatorTypeId: p?.tourOperatorTypeId,
        isInclusive: p?.isInclusive,
        isPublic: p?.isPublic,
        permanentDiscount: p?.permanentDiscount,

        // Partner document appended
        documents:
          p.documents?.map((doc) => {
            const latestVersion = doc.versions?.[0];
            const allHistories =
              doc.versions?.flatMap((version) =>
                (version.histories || []).map((hist) => ({
                  ...hist,
                  filePath: version.filePath, // ✅ attach correct file
                })),
              ) || [];

            return {
              id: String(doc.documentId ?? doc.id ?? ""),
              documentMasterId: String(doc?.documentMasterId ?? ""),
              name: doc.documentName ?? doc.name ?? "",
              status: doc.status ?? "",
              isRequired: Boolean(doc.isMandatory),
              uploadedUrl: latestVersion?.filePath ?? "",
              history: allHistories ?? [],
              file: null,
              acceptedFormats: doc?.acceptedFormats,
              maxFileSizeKB: doc?.maxFileSizeKB,
            };
          }) ?? [],

        addedAfterApproval: Boolean(p.addedAfterApproval),
        partnerId: "",
        mobile: "",
        parentOperatorId: "",
        firstName: "",
        middleName: "",
        lastName: "",
        arabicName: "",
        gender: "Male",
        displayOnPublicPage: false,
        isActualPartner: false,
        hasLogin: false,
        isLocked: false,
        status: "pending",
        registeredDate: "",
      }),
    );
    setPartners(mappedPartners);
  }, [selectedRegistration, refetchApi]);

  // SET OWNER CONFIG BYDEFAULT
  useEffect(() => {
    if (partners.length > 0 && !selectedPartnerForConfig) {
      const ownerPartner = partners.find((p) => p.role === "OWNER");
      if (ownerPartner) {
        setSelectedPartnerForConfig(ownerPartner);
      }
    }
  }, [partners, selectedPartnerForConfig]);

  const formatToInputDate = (dateString: string) => {
    if (!dateString) return "";
    const [datePart] = dateString.split(" ");
    const [month, day, year] = datePart.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  // SET SAVE CONFIG FORM FEILDS
  useEffect(() => {
    if (!selectedPartnerForConfig) return;

    const existingConfig = partnerConfigurations.find(
      (c) => c.partnerId === selectedPartnerForConfig.id,
    );
    if (existingConfig) {
      setPermissionDate(
        existingConfig.permissionDate ||
          (selectedPartnerForConfig.permissionExpireDate
            ? formatToInputDate(selectedPartnerForConfig.permissionExpireDate)
            : ""),
      );
      setToType(existingConfig.toType);
      setIsInclusive(existingConfig.isInclusive);
      setPermanentDiscount(existingConfig.permanentDiscount);
      setIsRequiredForPublic(existingConfig.isRequiredForPublic);
    } else {
      // Permission date (convert to YYYY-MM-DD if needed)
      setPermissionDate(
        selectedPartnerForConfig.permissionExpireDate
          ? formatToInputDate(selectedPartnerForConfig.permissionExpireDate)
          : "",
      );

      // Tour operator type
      setToType(
        selectedPartnerForConfig.tourOperatorTypeId
          ? String(selectedPartnerForConfig.tourOperatorTypeId)
          : "",
      );

      // Toggles
      setIsInclusive(Boolean(selectedPartnerForConfig.isInclusive));
      setIsRequiredForPublic(Boolean(selectedPartnerForConfig.isPublic));

      // Permanent discount
      setPermanentDiscount(
        selectedPartnerForConfig.permanentDiscount !== null &&
          selectedPartnerForConfig.permanentDiscount !== undefined
          ? String(selectedPartnerForConfig.permanentDiscount)
          : "",
      );
    }
  }, [selectedPartnerForConfig, partnerConfigurations]);

  // DELETE AREA OF OPERATION
  const handleRemoveArea = (area: AreaOfOperation) => {
    setAreaToDelete({
      areaId: String(area?.areaId),
      tourOperatorId: String(area.tourOperatorId),
    });
    setIsAreaDeleteOpen(true);
  };

  const handleConfirmDeleteArea = async () => {
    if (!areaToDelete) return;
    try {
      setIsDeleting(true);
      const response = await deleteAreaOfOperation(
        areaToDelete.tourOperatorId,
        areaToDelete.areaId,
      );
      if (response?.deleted) {
        setAreasOfOperation((prev) =>
          prev.filter(
            (area) => Number(area.areaId) !== Number(areaToDelete.areaId),
          ),
        );
        toast.success("Area of operation deleted successfully");
      }
    } catch (error) {
      toast.error("Failed to delete area of operation");
    } finally {
      setIsAreaDeleteOpen(false);
      setAreaToDelete(null);
      setIsDeleting(false);
    }
  };

  //DELETE PARTNERS START
  const handleConfirmRemovePartner = async () => {
    if (!partnerToRemove) return;

    try {
      setIsDeleting(true);

      const response = await deletePartners(
        partnerToRemove.tourOperatorId,
        partnerToRemove.id,
      );

      if (response?.deleted) {
        //Remove from local partners list
        setPartners((prev) => prev.filter((p) => p.id !== partnerToRemove.id));
        //Remove partner configuration (if exists)
        setPartnerConfigurations((prev) =>
          prev.filter((c) => c.partnerId !== partnerToRemove.id),
        );
        toast.success("Member removed successfully");
      }
    } catch (error: unknown) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to remove member";

      toast.error(errorMessage);
    } finally {
      setIsPartnerRemoveDialogOpen(false);
      setPartnerToRemove(null);
      setIsDeleting(false);
    }
  };

  //APPROVED PARTNER FUNCTION API CAL
  const handleConfirmApprovePartner = async () => {
    if (!partnerToApprove) return;

    try {
      setIsApprovingMember(true);
      const response = await approvePartner(
        partnerToApprove.tourOperatorId,
        partnerToApprove.id,
      );
      setPartners((current) =>
        current.map((partner) =>
          partner.id === partnerToApprove.id
            ? { ...partner, approvedStatus: 1 }
            : partner,
        ),
      );
      setSelectedRegistration((current) =>
        current
          ? {
              ...current,
              partners: current.partners.map((partner) =>
                String(partner.partnerId || partner.id) ===
                String(partnerToApprove.id)
                  ? { ...partner, approvedStatus: 1 }
                  : partner,
              ),
              pendingPartnerApprovalCount: Math.max(
                0,
                (current.pendingPartnerApprovalCount ?? 0) - 1,
              ),
            }
          : current,
      );
      toast.success(response?.message || "Member approved successfully");
    } catch (error: unknown) {
      let errorMessage = "Failed to approve member";
      if (axios.isAxiosError(error)) {
        const responseData = error.response?.data;
        if (typeof responseData === "string" && responseData.trim()) {
          errorMessage = responseData;
        } else if (
          responseData &&
          typeof responseData === "object" &&
          "message" in responseData &&
          typeof responseData.message === "string"
        ) {
          errorMessage = responseData.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }
      toast.error(errorMessage);
    } finally {
      setIsPartnerApproveDialogOpen(false);
      setPartnerToApprove(null);
      setIsApprovingMember(false);
    }
  };

  const handleAddArea = async () => {
    const newErrors: AreaErrors = {};

    if (!currentArea.countryId) {
      newErrors.countryId = "Please select a country for the area of operation";
    }

    if (!currentArea.cityId) {
      newErrors.cityId = "Please select a city for the area of operation";
    }

    if (!currentArea.address.trim()) {
      newErrors.address = "Please enter an address for the area of operation";
    }

    if (!currentArea.contactNumber.trim()) {
      newErrors.contactNumber =
        "Please enter a contact number for the area of operation";
    } else {
      const digits = currentArea.contactNumber.replace(/\D/g, "");
      if (digits.length < 10 || digits.length > 15) {
        newErrors.contactNumber =
          "Contact number must be between 10 and 15 digits";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const payload = {
      countryId: Number(currentArea.countryId),
      cityId:
        currentArea.cityId === "not_listed" ? 0 : Number(currentArea.cityId),
      otherCity: currentArea.otherCity || "",
      address: currentArea.address.trim(),
      contactNumber: currentArea.contactNumber.replace(/\D/g, ""),
      isAuthorizedGroupLeader: Boolean(
        selectedRegistration?.isAuthorizedGroupLead,
      ),
      tourOperatorId: Number(selectedRegistration?.tourOperatorId),
    };

    setLoading(true);
    const result = await AddAreaOfOpertaion(payload);
    if (!result.success) {
      toast.error(result.message);
      setLoading(false);
      return;
    }

    // // ✅ API SUCCESS → update UI
    const newArea = {
      ...currentArea,
      id: Date.now().toString(),
      areaId: Number(result.data.areaId),
      tourOperatorId: Number(selectedRegistration?.tourOperatorId),
      cityId:
        currentArea.cityId === "not_listed" ? 0 : Number(currentArea.cityId),
    };

    setAreasOfOperation((prev) => [...prev, newArea]);
    setCurrentArea({
      id: "",
      country: "",
      city: "",
      otherCity: "",
      address: "",
      contactNumber: "",
      countryId: "",
      cityId: "",
      tourOperatorId: "",
      areaId: "",
    });
    setLoading(false);
    setErrors({});
    toast.success("Area of operation added successfully");
  };

  const handleApproved = async () => {
    if (!selectedRegistration) return;
    const hasPartners = partners && partners.length > 0;

    if (hasPartners) {
      const mainOperator = partners.find((p) => p.isMainOperator === true);
      if (
        !mainOperator ||
        !mainOperator.permissionExpireDate ||
        !mainOperator.tourOperatorTypeId
      ) {
        toast.error("Please configure the main operator before approval");
        return;
      }
    } else {
      // Original validation for non-partner TOs
      if (!permissionDate) {
        toast.error("Please set permission expiry date");
        return;
      }

      if (!toType) {
        toast.error("Please select tour operator type");
        return;
      }
    }

    const missingMisalRequiredDocs = misaldocuments.filter(
      (doc) => doc.isRequired && !doc.file,
    );

    if (missingMisalRequiredDocs.length > 0) {
      toast.error("Please upload Misal Mubarak before approval");
      return false;
    }

    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append(
        "TourOperatorId",
        String(selectedRegistration.tourOperatorId),
      );
      // formData.append("UserId", String(user?.id || ""));
      // formData.append("CreatedBy", String(user?.id || ""));
      // formData.append("Remarks", remarks || "");
      // ✅ Append documents
      misaldocuments.forEach((doc, index) => {
        if (!doc.file) return; // ✅ guard
        formData.append(`Documents[${index}].documentMasterId`, String(doc.id));
        formData.append(`Documents[${index}].File`, doc.file);
        formData.append(`Documents[${index}].FileKey`, doc.file.name);
      });
      const result = await ApprovedTourOperator(
        Number(selectedRegistration.tourOperatorId),
        formData,
      );
      toast.success(
        result?.response?.data ?? "Registration Approved successfully",
      );
      navigate("/registration/list");
    } catch (error: unknown) {
      let errorMessage = "Failed to reject registration";
      if (axios.isAxiosError(error)) {
        if (typeof error.response?.data === "string") {
          errorMessage = error.response.data;
        } else {
          errorMessage = error.message;
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }
      toast.error(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  const handleReject = async () => {
    if (!selectedRegistration) return;

    if (!rejectReason.trim()) {
      toast.error("Please specify reason in Remarks for rejecting");
      return;
    }

    try {
      setIsUploading(true);
      const result = await rejectTourOperator(
        Number(selectedRegistration.tourOperatorId),
        rejectReason,
        Number(selectedRegistration.id), // if available
      );

      const updatedRegistration: TORegistration = {
        ...selectedRegistration,
        status: "rejected",
        rejectedReason: rejectReason,
      };
      setSelectedRegistration(updatedRegistration);

      toast.success(
        result?.response?.data ?? "Registration rejected successfully",
      );
      navigate("/registration/list");
    } catch (error: unknown) {
      let errorMessage = "Failed to reject registration";
      if (axios.isAxiosError(error)) {
        // If API sends plain string
        if (typeof error.response?.data === "string") {
          errorMessage = error.response.data;
        } else {
          errorMessage = error.message;
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }
      toast.error(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  const handleDeleteDocument = (docId: string) => {
    setDocumentToDelete(docId);
    setIsDeleteDialogOpen(true);
  };

  const toggleDocHistory = (docId: string) => {
    setExpandedDocHistory((prev) => ({
      ...prev,
      [docId]: !prev[docId],
    }));
  };

  const togglePartnerDocHistory = (key: string) => {
    setExpandedPartnerDocHistory((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const confirmDeleteDocument = async () => {
    if (!deleteRemark.trim()) {
      toast.error("Please provide a reason for document deletion");
      return;
    }
    if (!documentToDelete) return;
    try {
      setIsUploading(true);
      const result = await rejectTourOperatorDocument(
        Number(documentToDelete),
        deleteRemark,
      );
      // update UI after success
      setDocuments((prev) =>
        prev.map((doc) =>
          doc.id === documentToDelete
            ? { ...doc, uploadedUrl: undefined, file: null }
            : doc,
        ),
      );
      toast.success(result?.response?.data ?? "Document rejected successfully");
      setRefetchApi(!refetchApi);
      setIsDeleteDialogOpen(false);
      setDocumentToDelete(null);
      setDeleteRemark("");
    } catch (error: unknown) {
      let errorMessage = "Failed to reject document";
      if (axios.isAxiosError(error)) {
        if (typeof error.response?.data === "string") {
          errorMessage = error.response.data;
        } else {
          errorMessage = error.message;
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }
      toast.error(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  const handleNewConfirmUpload = async () => {
    if (!rejectedDoc || reUploadFiles.length === 0) {
      toast.error("Please select a file");
      return;
    }

    const file = reUploadFiles[0];
    /* ------------------ File Size Validation ------------------ */
    const maxSizeMB = Number(rejectedDoc?.maxFileSizeKB || 0) / 1024;
    const fileSizeMB = file.size / (1024 * 1024);

    if (fileSizeMB > maxSizeMB + 0.01) {
      toast.error(`File size must be less than or equal to ${maxSizeMB} MB`);
      return;
    }

    /* ------------------ Accepted Format Validation ------------------ */
    if (rejectedDoc?.acceptedFormats?.trim()) {
      const fileExtension = file.name.split(".").pop()?.toLowerCase();

      const allowedFormats = rejectedDoc.acceptedFormats
        .split(",")
        .map((f) => f.trim().toLowerCase())
        .filter(Boolean);

      if (!fileExtension || !allowedFormats.includes(fileExtension)) {
        toast.error(
          `Accepted format: ${allowedFormats.join(", ")} Only (Max ${formatFileSizeFromKB(
            rejectedDoc.maxFileSizeKB,
          )})`,
        );
        return;
      }
    }

    try {
      setIsUploading(true); // ✅ start loading
      const formData = new FormData();
      formData.append("File", file);
      formData.append(
        "TourOperatorId",
        String(selectedRegistration?.tourOperatorId),
      );
      formData.append("DocumentMasterId", String(rejectedDoc.documentMasterId));

      if (rejectedDoc.isPartner && rejectedDoc.partnerid) {
        formData.append("PartnerId", String(rejectedDoc.partnerid));
      }

      let response;

      if (rejectedDoc.isPartner) {
        response = await reUploadPartnersDocuments(formData);
      } else {
        response = await reUploadTourDocuments(formData);
      }

      toast.success(response || "Document re-uploaded successfully.");

      setRefetchApi(!refetchApi);
      setShowUploadDialog(false);
      setRejectedDoc(null);
      setReuploadFiles([]);
    } catch (error) {
      let errorMessage = "Failed to re-upload document";
      if (axios.isAxiosError(error)) {
        errorMessage =
          typeof error.response?.data === "string"
            ? error.response.data
            : error.message;
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }
      toast.error(errorMessage);
    } finally {
      setIsUploading(false); // ✅ stop loading (very important)
    }
  };

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "approved":
        return "bg-green-100 text-green-700 border-green-300";
      case "pending":
        return "bg-amber-100 text-amber-700 border-amber-300";
      case "rejected":
        return "bg-red-100 text-red-700 border-red-300";
      default:
        return "bg-gray-100 text-gray-700 border-gray-300";
    }
  };

  // Add More Partner on review Management Functions
  const handleOpenPartnerDialog = async () => {
    setIsPartnerDialogOpen(true);
    setAddPartnerErrors({});

    // setEditingPartner(null);
    // fetch partner documents
    // const partnerDocs = await fetchDocuments("partner");

    setPartnerFormData({
      id: "",
      isNonItsPartner: false,
      itsNumber: "",
      name: "",
      fullName: "",
      fatherName: "",
      email: "",
      mobileNumber: "",
      dateOfBirth: "",
      address: "",
      role: isSoleProprietor ? "office_staff" : "",
      isPartner: false,
      isOfficeStaff: isSoleProprietor,
      loginRequired: false,
      isAuthorizedGroupLeader: false,
      documents: documents.map((doc) => ({
        id: doc.id,
        documentMasterId: doc.documentMasterId,
        name: doc.name,
        status: doc.status,
        file: null,
        isRequired: doc.isRequired,
        acceptedFormats: doc?.acceptedFormats,
        maxFileSizeKB: doc?.maxFileSizeKB,
      })),
      addedAfterApproval: false,
    });

    // setPartnerITSError('');
    // setIsFetchingPartnerITS(false);
    // setIsPartnerDialogOpen(true);
  };

  const handlePartnerFileUpload = useCallback(
    (docId: string, file: File | null) => {
      setPartnerFormData({
        ...partnerFormData,
        documents: partnerFormData.documents.map((doc) =>
          doc.id === docId ? { ...doc, file } : doc,
        ),
      });
    },
    [partnerFormData],
  );

  const validatePartnerDocuments = useCallback(() => {
    if (!partnerFormData.isPartner) {
      return true;
    }

    const missingRequiredDocs = partnerFormData.documents.filter(
      (doc) => doc.isRequired && !doc.file,
    );

    if (missingRequiredDocs.length > 0) {
      return false;
    }

    return true;
  }, [partnerFormData.documents, partnerFormData.isPartner]);

  const handleSavePartner = useCallback(async () => {
    if (!selectedRegistration) {
      throw new Error("Selected registration is missing");
    }

    const errors: PartnerFormErrors = {};

    if (!partnerFormData.isNonItsPartner && !partnerFormData.itsNumber) {
      errors.itsNumber = "ITS number is required";
    }

    if (!partnerFormData.name) {
      errors.name = "Name is required";
    }

    const normalizedEmail = partnerFormData.email.trim().toLowerCase();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!normalizedEmail) {
      errors.email = "Email is required";
    } else if (!emailPattern.test(normalizedEmail)) {
      errors.email = "Please enter a valid email address";
    }

    if (!partnerFormData.mobileNumber) {
      errors.mobileNumber = "Mobile number is required";
    }

    if (!partnerFormData.isPartner && !partnerFormData.isOfficeStaff) {
      errors.memberType = "Please select Partner or Office Staff";
    }

    if (!validatePartnerDocuments()) {
      errors.documents = "Please upload all required documents";
    }

    // Stop submit if errors exist
    if (Object.keys(errors).length > 0) {
      setAddPartnerErrors(errors);
      return;
    }

    // DUPLICATE EMAIL CHECK FROM EXISTING PARTNERS
    const isEmailExists = partners.some(
      (p) => p.email.toLowerCase() === normalizedEmail,
    );
    if (isEmailExists) {
      setAddPartnerErrors((prev) => ({
        ...prev,
        email: "This email already exists",
      }));
      return;
    }

    // Clear errors on success
    setAddPartnerErrors({});
    try {
      const formData = new FormData();
      formData.append("itsNumber", partnerFormData.itsNumber);
      formData.append(
        "IsNonIts",
        partnerFormData.isNonItsPartner ? "true" : "false",
      );
      formData.append("name", partnerFormData.name);
      formData.append("email", partnerFormData.email);
      formData.append("mobile", partnerFormData.mobileNumber);
      formData.append(
        "role",
        partnerFormData.isPartner ? "PARTNER" : "OFFICE_STAFF",
      );
      formData.append("loginRequired", String(partnerFormData.loginRequired));
      formData.append(
        "isAuthorizedGroupLeader",
        String(partnerFormData.isAuthorizedGroupLeader),
      );
      formData.append("isMainOperator", "false");
      formData.append(
        "tourOperatorId",
        String(selectedRegistration?.tourOperatorId),
      );

      if (partnerFormData.isPartner) {
        partnerFormData.documents.forEach((doc, index) => {
          if (doc.file) {
            formData.append(
              `Documents[${index}].documentMasterId`,
              String(doc.documentMasterId),
            );
            formData.append(`Documents[${index}].file`, doc.file);
            formData.append(`Documents[${index}].FileKey`, doc.file.name);
          }
        });
      }

      const result = await AddNewPartners(formData);
      if (!result?.success) {
        toast.error(result?.message || "Failed to add partner");
        return;
      }
      // ✅ manually add partner to UI state
      // const newPartner = createLocalPartnerFromPayload(payload);
      // setPartners(prev => [...prev, newPartner]);
      toast.success("Member added successfully");
      setRefetchApi(!refetchApi);
    } catch (error: unknown) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Something went wrong. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsPartnerDialogOpen(false);
    }
  }, [
    partnerFormData,
    selectedRegistration,
    validatePartnerDocuments,
    refetchApi,
    partners,
  ]);

  const validateConfigurationForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!permissionDate) {
      newErrors.permissionDate = "Permission expiry date is required";
    } else if (permissionDate < minimumPermissionDate) {
      newErrors.permissionDate = "Permission expiry date cannot be in the past";
    }

    if (!toType) {
      newErrors.toType = "Tour operator type is required";
    }

    if (isInclusive && !permanentDiscount) {
      newErrors.permanentDiscount = "Permanent discount is required";
    }

    if (permanentDiscount && isNaN(Number(permanentDiscount))) {
      newErrors.permanentDiscount = "Permanent discount must be a valid number";
    }

    setConfigErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSaveConfiguration = async () => {
    if (!selectedPartnerForConfig) {
      toast.error("Please select a partner");
      return;
    }

    if (!validateConfigurationForm()) return;

    const newConfig: PartnerConfiguration = {
      partnerId: selectedPartnerForConfig.id,
      permissionDate,
      toType,
      isInclusive,
      permanentDiscount,
      isRequiredForPublic,
    };

    try {
      setLoading(true);

      // ✅ API CALL (only once)
      await saveConfigurations(
        Number(selectedPartnerForConfig.tourOperatorId),
        Number(selectedPartnerForConfig.id),
        {
          tourOperatorId: Number(selectedPartnerForConfig.tourOperatorId),
          partnerId: Number(selectedPartnerForConfig.id),
          permissionExpireDate: permissionDate,
          tourOperatorTypeId: Number(toType),
          isInclusive,
          isPublic: isRequiredForPublic,
          permanentDiscount: Number(permanentDiscount) || 0,
        },
      );

      // ✅ UPDATE LOCAL CONFIG STATE
      setPartnerConfigurations((prev) => {
        const index = prev.findIndex(
          (c) => c.partnerId === selectedPartnerForConfig.id,
        );

        if (index !== -1) {
          const updated = [...prev];
          updated[index] = newConfig;
          return updated;
        }

        return [...prev, newConfig];
      });

      toast.success("Configuration saved successfully");
      setRefetchApi(!refetchApi);
    } catch (error: unknown) {
      toast.error(
        error instanceof Error ? error.message : "Failed to save configuration",
      );
    } finally {
      setLoading(false);
    }
  };


  // Form View
  return (
    <>
      {loading && <FullScreenLoading />}
      <div className="space-y-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-2">
            {/* <Button
              onClick={() => navigate(-1)}
              variant="ghost"
              size="sm"
              className="text-[#5B9BD5] hover:bg-[#5B9BD5]/10 -ml-2"
            >
              <ArrowLeft className="w-5 h-5" />
            </Button> */}
            <div>
              {/* <h1 style={{ color: '#5B9BD5' }} className="flex items-center gap-2 ml-2 font-medium">
                <FileText className="w-6 h-6" />
                <p className="text-[#5B9BD5] font-semibold mt-1">Review Tour Operator Registration</p>
              </h1> */}
              <p className="text-gray-600 mt-1">
                ITS: {selectedRegistration?.itsNumber} -{" "}
                {selectedRegistration?.officeName}
              </p>
            </div>
          </div>
          <Badge
            variant="outline"
            className={`${getStatusColor(selectedRegistration?.status || "pending")} text-[14px] px-4 py-2`}
          >
            {selectedRegistration?.status}
          </Badge>
        </div>

        {/* ITS Verified Information - Read Only */}
        <Card className="border-[#5B9BD5]/30 bg-white shadow-lg">
          <CardHeader>
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-5 h-5" style={{ color: "#5B9BD5" }} />
              <CardTitle className="text-gray-900">
                Verified Personal Information (ITS Data)
              </CardTitle>
            </div>
            <p className="text-sm text-gray-600 mt-1">
              Information verified from ITS system (read-only - cannot be
              modified)
            </p>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="space-y-2 cursor-not-allowed">
                <InputFieldset
                  label="ITS Number"
                  id="itsNumber"
                  value={selectedRegistration?.itsNumber || "N/A"}
                  readOnly
                  disabled
                  tabIndex={-1}
                  className="!bg-gray-100 cursor-not-allowed pointer-events-none font-mono tracking-wider [&_legend]:!bg-gray-100"
                />
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="First Name"
                  // required
                  id="firstName"
                  value={firstName}
                  onChange={(e) => {
                    const value = removeFullSpecialCharacters(e.target.value);
                    setFirstName(value);
                  }}
                  placeholder="Enter first name"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                  readOnly
                />
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Middle Name"
                  // required
                  readOnly
                  id="middleName"
                  value={middleName}
                  onChange={(e) => {
                    const value = removeFullSpecialCharacters(e.target.value);
                    setMiddleName(value);
                  }}
                  placeholder="Enter middle name"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Last Name"
                  // required
                  readOnly
                  id="lastName"
                  value={lastName}
                  onChange={(e) => {
                    const value = removeFullSpecialCharacters(e.target.value);
                    setLastName(value);
                  }}
                  placeholder="Enter last name"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              <div className="space-y-2 lg:col-span-2">
                <InputFieldset
                  label="Arabic Name"
                  // required
                  readOnly
                  id="arabicName"
                  value={arabicName}
                  onChange={(e) => {
                    const value = removeFullSpecialCharacters(e.target.value);
                    setArabicName(value);
                  }}
                  placeholder="Enter Arabic name"
                  dir="rtl"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              <div className="space-y-2">
                <SelectFieldset
                  label="Gender"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                >
                  <Select
                    value={gender}
                    onValueChange={setGender}
                    // disabled={activeTab !== 'pending'}
                    disabled={true}
                  >
                    <SelectTriggerUI
                      id="gender"
                      className="cursor-not-allowed !bg-gray-100 border-0 shadow-none"
                    >
                      <SelectValue placeholder="Select gender" />
                    </SelectTriggerUI>
                    <SelectContent>
                      <SelectItem value="Male">Male</SelectItem>
                      <SelectItem value="Female">Female</SelectItem>
                    </SelectContent>
                  </Select>
                </SelectFieldset>
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Date of Birth"
                  // required
                  readOnly
                  id="dateOfBirth"
                  type="date"
                  value={dateOfBirth}
                  onChange={(e) => setDateOfBirth(e.target.value)}
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Editable Additional Information */}
        <Card className="border-[#5B9BD5]/20 bg-white shadow-lg">
          <CardHeader>
            <div className="flex items-center gap-2">
              <User className="w-5 h-5" style={{ color: "#5B9BD5" }} />
              <CardTitle className="text-gray-900">
                Additional Information
              </CardTitle>
            </div>
            <p className="text-sm text-gray-600 mt-1">
              {activeTab === "pending"
                ? "Review and edit if needed"
                : "Read-only view"}
            </p>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="space-y-2">
                <InputFieldset
                  label="Whatsapp Username"
                  // required
                  readOnly
                  id="whatsappUsername"
                  value={whatsappUsername}
                  onChange={(e) => {
                    setWhatsappUsername(e.target.value);
                  }}
                  placeholder="e.g., john_doe"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              {/* <div className="space-y-2">
                <InputFieldset
                  label="Passport Number"
                  // required
                  readOnly
                  id="passportNumber"
                  value={passportNumber}
                  onChange={(e) => {
                    const value = removeSpecialCharacters(e.target.value);
                    setPassportNumber(value);
                  }}
                  placeholder="e.g., A1234567"
                  className="cursor-not-allowed bg-white border-gray-300 rounded-xl"
                  disabled={activeTab !== "pending"}
                />
              </div> */}

              <div className="space-y-2">
                <InputFieldset
                  label="Mobile Number"
                  // required
                  readOnly
                  id="mobileNumber"
                  value={mobileNumber}
                  onChange={(e) => {
                    const value = validatePhoneNumberInput(e.target.value);
                    setMobileNumber(value);
                  }}
                  placeholder="+964-XXX-XXXXXXX"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Alternate Mobile Number"
                  id="alternateMobile"
                  value={alternateMobile}
                  readOnly
                  onChange={(e) => {
                    const value = validatePhoneNumberInput(e.target.value);
                    setAlternateMobile(value);
                  }}
                  placeholder="+964-XXX-XXXXXXX"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Office Contact Number"
                  // required
                  readOnly
                  id="officeNumber"
                  value={officeNumber}
                  onChange={(e) => {
                    const value = validatePhoneNumberInput(e.target.value);
                    setOfficeNumber(value);
                  }}
                  placeholder="+964-XXX-XXXXXXX"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              <div className="space-y-2 lg:col-span-2">
                <InputFieldset
                  label="Office Name (Read-Only)"
                  id="officeName"
                  value={officeName}
                  readOnly
                  // disabled
                  tabIndex={-1}
                  className="!bg-gray-100 cursor-not-allowed text-gray-900 [&_legend]:!bg-gray-100"
                />
              </div>

              <div className="space-y-2 lg:col-span-2">
                <InputFieldset
                  label="Business Type"
                  id="businessType"
                  // value={selectedRegistration?.businessType || "Not specified"}
                  value={
                    selectedRegistration?.businessType
                      ? toSentenceCase(selectedRegistration.businessType)
                      : "Not specified"
                  }
                  // required
                  readOnly
                  disabled
                  tabIndex={-1}
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                />
              </div>

              <div className="space-y-2 lg:col-span-2">
                <SelectFieldset
                  label="Country"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                >
                  <Popover
                    open={countryComboOpen}
                    onOpenChange={setCountryComboOpen}
                  >
                    <PopoverTrigger asChild>
                      <PopoverTriggerUI
                        variant="outline"
                        role="combobox"
                        disabled={true}
                        aria-expanded={countryComboOpen}
                        className="!cursor-not-allowed w-full justify-between !bg-gray-100 border-0 shadow-none"
                        // disabled={activeTab !== 'pending'}
                      >
                        {country
                          ? countriesList.find(
                              (c) => String(c.countryId) === country,
                            )?.countryName
                          : "Select country..."}
                        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                      </PopoverTriggerUI>
                    </PopoverTrigger>
                    <PopoverContent className="cursor-not-allowed min-w-[300px] w-full p-0">
                      <Command>
                        <CommandInput
                          placeholder="Search country..."
                          className="h-9 focus:outline-none focus:ring-0 focus:border-transparent"
                        />
                        <CommandEmpty>No country found.</CommandEmpty>
                        <CommandGroup className="max-h-[300px] overflow-y-auto">
                          {countriesList.map((c) => (
                            <CommandItem
                              key={c.countryId}
                              value={c.countryName}
                              onSelect={() => {
                                setCountry(String(c.countryId));
                                setCity("");
                                setCountryComboOpen(false);
                              }}
                            >
                              {c.countryName}
                              <Check
                                className={cn(
                                  "cursor-not-allowed ml-auto h-4 w-4",
                                  country === String(c.countryId)
                                    ? "opacity-100"
                                    : "opacity-0",
                                )}
                              />
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </Command>
                    </PopoverContent>
                  </Popover>
                </SelectFieldset>
              </div>

              <div className="space-y-2 lg:col-span-2">
                <InputFieldset
                  label="City"
                  // required
                  readOnly
                  id="city"
                  value={city.trim() && city !== "0" ? city : otherCity}
                  onChange={(e) => setCity(e.target.value)}
                  placeholder="Enter city"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              {otherCity && (
                <div className="hidden space-y-2 lg:col-span-2">
                  <InputFieldset
                    label="Other City (if not listed)"
                    id="otherCity"
                    value={otherCity}
                    onChange={(e) => setOtherCity(e.target.value)}
                    placeholder="Enter city name if not in the list"
                    className="!bg-gray-100 bg-input-background border-gray-300 cursor-not-allowed  rounded-lg [&_legend]:!bg-gray-100"
                    disabled={activeTab !== "pending"}
                  />
                </div>
              )}

              <div className="space-y-2 lg:col-span-4">
                <SelectFieldset
                  label="Permanent Address"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                >
                  <TextareaUI
                    id="permanentAddress"
                    readOnly
                    value={permanentAddress}
                    onChange={(e) => setPermanentAddress(e.target.value)}
                    placeholder="Enter your complete permanent address"
                    className="cursor-not-allowed min-h-[100px] !bg-gray-100 border-0 resize-none"
                    disabled={activeTab !== "pending"}
                  />
                </SelectFieldset>
              </div>

              {/* Authorized Group Leader - Only show if business type is Sole Proprietorship */}
              {selectedRegistration?.businessType === "Sole Proprietorship" && (
                <div className="space-y-2 lg:col-span-4">
                  <div className="flex items-center space-x-2 pt-2">
                    <Checkbox
                      id="isAuthorizedGroupLeader"
                      checked={isAuthorizedGroupLead}
                      onCheckedChange={(checked) =>
                        setIsAuthorizedGroupLead(!!checked)
                      }
                      disabled={activeTab !== "pending"}
                    />
                    <label
                      htmlFor="isAuthorizedGroupLeader"
                      className="text-sm text-gray-900 cursor-pointer"
                    >
                      Authorized Group Leader
                    </label>
                  </div>
                </div>
              )}
            </div>
          </CardContent>
        </Card>

        {/* UPLOAD DOCUMENTS */}
        <Card className="border-[#5B9BD5]/20 bg-white shadow-lg">
          <CardHeader>
            <div className="flex items-center gap-2">
              <FileText className="w-5 h-5" style={{ color: "#5B9BD5" }} />
              <CardTitle className="text-gray-900">
                Uploaded Documents <span className="text-red-500">*</span>
              </CardTitle>
            </div>
            <p className="text-sm text-gray-600 mt-1">
              Required documents submitted by the applicant
            </p>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {documents.map((doc, index) => (
                <div
                  key={doc.id}
                  className="border border-gray-200 rounded-lg overflow-hidden"
                >
                  {/* Document Row */}
                  <div className="bg-white hover:bg-gray-50 transition-colors p-4">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
                      <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 text-gray-900 flex-shrink-0">
                        {index + 1}
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-gray-900">
                          {doc.name || doc.documentName}
                          {doc.isRequired ||
                            (doc?.isMandatory && (
                              <span className="text-red-500 ml-1">*</span>
                            ))}
                        </p>
                        <p className="text-xs text-red-400">
                          {`Accepted format: ${doc.acceptedFormats} (Max ${formatFileSizeFromKB(
                            doc.maxFileSizeKB,
                          )})`}
                        </p>
                      </div>
                      <div className="flex flex-wrap items-center gap-2 sm:gap-3 w-full sm:w-auto">
                        {doc.uploadedUrl && doc.status !== "REJECTED" ? (
                          <>
                            <CheckCircle2 className="w-5 h-5 text-green-600" />
                            <span className="text-sm text-gray-700">
                              Document uploaded
                            </span>
                            <button
                              className="hover:bg-gray-100 rounded-lg p-1.5 transition-colors"
                              style={{ color: "#5B9BD5" }}
                            >
                              <Eye
                                className="w-4 h-4 cursor-pointer"
                                onClick={() => {
                                  const fullUrl = getFileViewUrl(
                                    doc.uploadedUrl,
                                  );
                                  window.open(fullUrl, "_blank");
                                }}
                              />
                            </button>
                          </>
                        ) : (
                          <span className="text-sm text-gray-500">
                            Not uploaded
                          </span>
                        )}
                        {isSuperAdmin &&
                          doc.history &&
                          doc.history.length > 0 && (
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => toggleDocHistory(doc.id)}
                              className="text-sm border-gray-300 hover:bg-gray-50 rounded-xl flex items-center gap-1"
                            >
                              <History className="w-3 h-3" />
                              History ({doc.history.length})
                              {expandedDocHistory[doc.id] ? (
                                <ChevronUp className="w-3 h-3" />
                              ) : (
                                <ChevronDown className="w-3 h-3" />
                              )}
                            </Button>
                          )}

                        {/* Upload And Reject Doc Button - Always visible */}
                        {doc.status !== "REJECTED" && doc.uploadedUrl ? (
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => handleDeleteDocument(doc.id)}
                            className="text-red-600 hover:text-red-700 hover:bg-red-50 rounded-xl"
                          >
                            {canDelete && <Trash2 className="w-4 h-4" />}
                          </Button>
                        ) : (
                          <Button
                            size="sm"
                            onClick={() => {
                              setRejectedDoc({ ...doc, isPartner: false });
                              setShowUploadDialog(true);
                            }}
                            style={{ backgroundColor: "#5B9BD5" }}
                            className="text-white text-xs"
                          >
                            <Upload className="w-3.5 h-3.5 mr-1" />
                            Upload
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Document History - Super Admin Only */}
                  {isSuperAdmin &&
                    doc.versions &&
                    doc.versions.length > 0 &&
                    expandedDocHistory[doc.id] && (
                      <div className="bg-gradient-to-r from-blue-50 to-white border-t border-gray-200 p-4">
                        <h4
                          className="text-sm mb-3"
                          style={{ color: "#5B9BD5" }}
                        >
                          📋 Document Upload History ({doc.versions.length}{" "}
                          versions)
                        </h4>

                        <div className="space-y-4">
                          {doc.versions.map((version, versionIndex) => (
                            <div key={versionIndex}>
                              {/* <div className="text-xs font-semibold text-gray-700 mb-2">
                                Version {version.id}
                              </div> */}

                              {version.histories?.map((hist, histIndex) => (
                                <div
                                  key={hist.id || histIndex}
                                  className={`p-3 rounded-lg border mb-2 ${
                                    hist.historyStatus?.toLowerCase() ===
                                    "approved"
                                      ? "bg-green-50 border-green-200"
                                      : hist.historyStatus?.toLowerCase() ===
                                          "rejected"
                                        ? "bg-red-50 border-red-200"
                                        : "bg-gray-50 border-gray-200"
                                  }`}
                                >
                                  <div className="flex items-start justify-between gap-3">
                                    <div className="flex-1">
                                      <div className="flex items-center gap-2 mb-1">
                                        <Badge
                                          className={`text-xs ${
                                            hist.historyStatus?.toLowerCase() ===
                                            "approved"
                                              ? "bg-green-100 text-green-700 border-green-300"
                                              : hist.historyStatus?.toLowerCase() ===
                                                  "rejected"
                                                ? "bg-red-100 text-red-700 border-red-300"
                                                : "bg-gray-100 text-gray-700 border-gray-300"
                                          }`}
                                        >
                                          {hist.historyStatus
                                            ? hist.historyStatus.toUpperCase()
                                            : "PENDING"}
                                        </Badge>

                                        {hist.actionAt && (
                                          <span className="text-xs text-gray-600">
                                            {
                                              formatUploadedDateTime(
                                                hist.actionAt,
                                              ).date
                                            }{" "}
                                            at{" "}
                                            {
                                              formatUploadedDateTime(
                                                hist.actionAt,
                                              ).time
                                            }
                                          </span>
                                        )}
                                      </div>

                                      {hist.remarks && (
                                        <p className="text-xs text-gray-700 mt-1">
                                          <span className="text-gray-900">
                                            Remarks:
                                          </span>{" "}
                                          {hist.remarks}
                                        </p>
                                      )}
                                    </div>

                                    {/* ✅ View file of that specific version */}
                                    <button
                                      className="hover:bg-gray-100 rounded-lg p-1 transition-colors flex-shrink-0"
                                      style={{ color: "#5B9BD5" }}
                                      onClick={() => {
                                        if (!version.filePath) return;
                                        const fullUrl = getFileViewUrl(
                                          version.filePath,
                                        );
                                        window.open(fullUrl, "_blank");
                                      }}
                                    >
                                      <Eye className="w-4 h-4 cursor-pointer" />
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* AREA OF OPERATIONS */}
        <Card className="border-[#5B9BD5]/20 bg-white shadow-lg bg-white">
          <CardHeader>
            <div className="flex items-center gap-2">
              <MapPin className="w-5 h-5" style={{ color: "#5B9BD5" }} />
              <CardTitle className="text-gray-900">
                Area of Operations
              </CardTitle>
            </div>
            <p className="text-sm text-gray-600 mt-1">
              Areas where the operator conducts tour business
            </p>
          </CardHeader>
          <CardContent className="space-y-6 bg-white">
            {/* Add Area Form - Only for pending */}
            {canAdd && activeTab === "pending" && (
              <div
                className="p-6 rounded-lg border-2 border-dashed space-y-4"
                style={{ borderColor: "#5B9BD5" }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div className="space-y-2">
                    <SelectFieldset label="Country" required>
                      <Popover
                        open={areaCountryComboOpen}
                        onOpenChange={setAreaCountryComboOpen}
                      >
                        <PopoverTrigger asChild>
                          <PopoverTriggerUI
                            variant="outline"
                            role="combobox"
                            aria-expanded={areaCountryComboOpen}
                            className="w-full justify-between bg-white border-gray-300 rounded-xl"
                          >
                            {currentArea.countryId
                              ? countriesList.find(
                                  (c) =>
                                    String(c.countryId) ===
                                    currentArea.countryId,
                                )?.countryName
                              : "Select country..."}
                            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                          </PopoverTriggerUI>
                        </PopoverTrigger>
                        <PopoverContent className="w-full p-0">
                          <Command>
                            <CommandInput
                              placeholder="Search country..."
                              className="focus:outline-none focus:ring-0 focus:border-transparent"
                            />
                            <CommandEmpty>No country found.</CommandEmpty>
                            <CommandGroup className="max-h-[300px] overflow-y-auto">
                              {countriesList.map((c) => (
                                <CommandItem
                                  key={c.countryId}
                                  value={c.countryName}
                                  onSelect={() => {
                                    setCurrentArea({
                                      ...currentArea,
                                      countryId: String(c.countryId),
                                      city: "",
                                      otherCity: "",
                                    });
                                    // setCountry(String(c.countryId));
                                    setCity("");
                                    setAreaCountryComboOpen(false);
                                  }}
                                >
                                  {c.countryName}
                                  <Check
                                    className={cn(
                                      "ml-auto h-4 w-4",
                                      country === String(c.countryId)
                                        ? "opacity-100"
                                        : "opacity-0",
                                    )}
                                  />
                                </CommandItem>
                              ))}
                            </CommandGroup>
                          </Command>
                        </PopoverContent>
                      </Popover>
                    </SelectFieldset>
                    {errors.countryId && (
                      <p className="text-red-400 text-xs">{errors.countryId}</p>
                    )}
                  </div>

                  <div className="space-y-2">
                    <SelectFieldset label="City" required>
                      <Popover
                        open={areaCityComboOpen}
                        onOpenChange={setAreaCityComboOpen}
                      >
                        <PopoverTrigger asChild>
                          <PopoverTriggerUI
                            variant="outline"
                            role="combobox"
                            aria-expanded={areaCityComboOpen}
                            className="w-full justify-between bg-white border-gray-300 rounded-xl"
                            disabled={!currentArea.countryId}
                          >
                            {currentArea.cityId === "not_listed"
                              ? "Not Listed"
                              : currentArea.cityId
                                ? selectedAreaCountry?.cities.find(
                                    (c) =>
                                      String(c.cityId) === currentArea.cityId,
                                  )?.cityName
                                : "Select city..."}
                            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                          </PopoverTriggerUI>
                        </PopoverTrigger>
                        <PopoverContent className="w-full p-0">
                          <Command>
                            <CommandInput
                              placeholder="Search city..."
                              className="h-9 focus:outline-none focus:ring-0 focus:border-transparent"
                            />
                            <CommandEmpty>No city found.</CommandEmpty>
                            <CommandGroup className="max-h-[300px] overflow-y-auto">
                              {selectedAreaCountry?.cities.map((c) => (
                                <CommandItem
                                  key={c.cityId}
                                  value={c.cityName}
                                  onSelect={() => {
                                    setCurrentArea({
                                      ...currentArea,
                                      cityId: String(c.cityId),
                                      otherCity: "",
                                    });
                                    setAreaCityComboOpen(false);
                                  }}
                                >
                                  {c.cityName}
                                  <Check
                                    className={cn(
                                      "ml-auto h-4 w-4",
                                      currentArea.city === String(c.cityId)
                                        ? "opacity-100"
                                        : "opacity-0",
                                    )}
                                  />
                                </CommandItem>
                              ))}
                              <CommandItem
                                value="not_listed"
                                onSelect={() => {
                                  setCurrentArea({
                                    ...currentArea,
                                    cityId: "not_listed",
                                  });
                                  setAreaCityComboOpen(false);
                                }}
                              >
                                Not Listed
                                <Check
                                  className={cn(
                                    "ml-auto h-4 w-4",
                                    currentArea.city === "not_listed"
                                      ? "opacity-100"
                                      : "opacity-0",
                                  )}
                                />
                              </CommandItem>
                            </CommandGroup>
                          </Command>
                        </PopoverContent>
                      </Popover>
                    </SelectFieldset>
                    {errors.cityId && (
                      <p className="text-red-400 text-xs">{errors.cityId}</p>
                    )}
                  </div>

                  {currentArea.cityId === "not_listed" && (
                    <div className="space-y-2">
                      <InputFieldset
                        label="Other City"
                        id="areaOtherCity"
                        value={currentArea.otherCity}
                        onChange={(e) =>
                          setCurrentArea({
                            ...currentArea,
                            otherCity: e.target.value,
                          })
                        }
                        placeholder="If not listed"
                        className="bg-white border-gray-300 rounded-xl"
                      />
                    </div>
                  )}

                  <div className="space-y-2 md:col-span-2">
                    <InputFieldset
                      label="Address"
                      required
                      id="areaAddress"
                      value={currentArea.address}
                      onChange={(e) =>
                        setCurrentArea({
                          ...currentArea,
                          address: e.target.value,
                        })
                      }
                      placeholder="Enter complete address"
                      className="bg-white border-gray-300 rounded-xl"
                    />
                    {errors.address && (
                      <p className="text-red-400 text-xs">{errors.address}</p>
                    )}
                  </div>

                  <div className="space-y-2">
                    <InputFieldset
                      label="Contact Number"
                      required
                      id="areaContact"
                      value={currentArea.contactNumber}
                      onChange={(e) => {
                        const value = validatePhoneNumberInput(e.target.value);
                        setCurrentArea({
                          ...currentArea,
                          contactNumber: value,
                        });
                      }}
                      placeholder="+XXX-XXX-XXXXXXX"
                      className="bg-white border-gray-300 rounded-xl"
                    />
                    {errors.contactNumber && (
                      <p className="text-red-400 text-xs">
                        {errors.contactNumber}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex justify-end">
                  <Button
                    type="button"
                    onClick={handleAddArea}
                    className="text-white shadow-lg hover:opacity-90 transition-opacity rounded-xl w-full sm:w-auto"
                    style={{ backgroundColor: "#5B9BD5" }}
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Add Area
                  </Button>
                </div>
              </div>
            )}

            {/* Display added areas */}
            {areasOfOperation.length > 0 && (
              <div className="space-y-3">
                <Label className="text-gray-900">
                  Added Areas ({areasOfOperation.length})
                </Label>
                <div className="space-y-2">
                  {areasOfOperation.map((area, index) => {
                    const areaCountry = countriesList.find(
                      (c) => String(c.countryId) === String(area.countryId),
                    );
                    const areaCity = areaCountry?.cities.find(
                      (c) => c.cityId === area.cityId,
                    );
                    return (
                      <div
                        key={area.id || index}
                        className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 bg-white rounded-lg border border-gray-200 hover:border-[#5B9BD5]/50 transition-colors gap-3"
                      >
                        <div className="flex-1 w-full">
                          <div className="flex items-center gap-2 mb-1">
                            <span
                              className="flex items-center justify-center w-6 h-6 rounded-full text-xs text-white flex-shrink-0"
                              style={{ backgroundColor: "#5B9BD5" }}
                            >
                              {index + 1}
                            </span>
                            <p className="text-gray-900 break-words">
                              {areaCountry?.countryName} - {areaCity?.cityName}
                              {area.otherCity && ` (${area.otherCity})`}
                            </p>
                          </div>
                          <p className="text-sm text-gray-600 ml-0 sm:ml-8 break-words">
                            {area.address} • {area.contactNumber}
                          </p>
                        </div>
                        {activeTab === "pending" && (
                          <Button
                            type="button"
                            variant="ghost"
                            size="sm"
                            onClick={() => handleRemoveArea(area)}
                            className="text-red-600 hover:text-red-700 hover:bg-red-50 self-end sm:self-auto"
                          >
                            {canDelete && <X className="w-4 h-4" />}
                          </Button>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </CardContent>
        </Card>

        {/* Delete area of operation confirmpopup*/}
        <ConfirmDialog
          open={isAreaDeleteOpen}
          onOpenChange={setIsAreaDeleteOpen}
          title="Delete Area"
          description="Do you really want to delete?"
          confirmText="Delete"
          loading={isDeleting}
          onConfirm={handleConfirmDeleteArea}
        >
          {/* <p className="text-sm text-gray-700">
            Document Name: {selectedDoc?.name}
          </p> */}
        </ConfirmDialog>

        {/* Member Details & Documents */}
        {partners && partners.length > 0 && (
          <Card
            className="border-[#5B9BD5]/20 bg-white shadow-lg"
            style={{ marginTop: "10px" }}
          >
            <CardHeader>
              <div className="flex justify-between items-center">
                <div>
                  <div className="flex items-center gap-2">
                    <Users className="w-5 h-5" style={{ color: "#5B9BD5" }} />
                    <CardTitle className="text-gray-900">
                      Member Details & Documents
                    </CardTitle>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    Review and edit member information. All fields except ITS
                    Number are editable. (
                    {partners.filter((p) => !p?.isMainOperator).length}{" "}
                    {partners.filter((p) => !p?.isMainOperator).length === 1
                      ? "member"
                      : "members"}
                    )
                  </p>
                </div>
                <div>
                  {/* ADD PARTNER POPUP */}
                  {canAdd && (
                    <Button
                      type="button"
                      onClick={handleOpenPartnerDialog}
                      className="h-9 px-4 text-white rounded-lg shadow-sm flex items-center gap-2 bg-blue-500"
                      // style={{ backgroundColor: '#10B981' }}
                    >
                      <Plus className="w-4 h-4" />
                      Add Member
                    </Button>
                  )}
                </div>
              </div>

              {/* Alert for New Partners Added After Approval */}
              {pendingPartnerApprovalCount > 0 && (
                <Alert
                  className="mt-3 border-amber-400 bg-gradient-to-r from-amber-50 to-orange-50"
                  style={{ marginTop: "0px" }}
                >
                  <AlertCircle className="h-4 w-4 text-amber-600" />
                  <AlertDescription className="text-sm text-amber-900 ml-2">
                    <strong className="font-semibold">
                      ⚠️ Attention Required:
                    </strong>{" "}
                    {pendingPartnerApprovalCount} new{" "}
                    {pendingPartnerApprovalCount === 1
                      ? "member has"
                      : "members have"}{" "}
                    been added after the initial approval and{" "}
                    {pendingPartnerApprovalCount === 1 ? "requires" : "require"}{" "}
                    review. These members are highlighted in amber below.
                  </AlertDescription>
                </Alert>
              )}
            </CardHeader>
            <CardContent className="space-y-6">
              {partners
                .filter((partner) => !partner.isMainOperator)
                .map((partner, index) => (
                  <div
                    key={partner.id || index}
                    className={`p-6 rounded-lg border-2 bg-white space-y-4 ${
                      partner.approvedStatus === 0
                        ? "border-red-400 shadow-lg"
                        // : partner.addedAfterApproval
                        //   ? "border-amber-400 shadow-lg"
                          : "border-gray-200"
                    }`}
                  >
                    {/* Member Header */}
                    <div className="flex items-center justify-between pb-3 border-b border-gray-200">
                      <div className="flex items-center gap-3">
                        <span
                          className="flex items-center justify-center w-10 h-10 rounded-full text-white"
                          style={{ backgroundColor: "#5B9BD5" }}
                        >
                          {index + 1}
                        </span>
                        <div>
                          <h3 className="text-gray-900">Member {index + 1}</h3>
                          <p className="text-sm text-gray-600 font-mono">
                            ITS: {partner.itsNumber}
                          </p>
                        </div>
                      </div>
                      {activeTab === "pending" && (
                        <div className="flex items-center gap-2">
                          {canEdit &&
                            partner.approvedStatus === 0 &&
                            selectedRegistration?.status?.toLowerCase() ===
                              "approved" && (
                              <Button
                                size="sm"
                                onClick={() => {
                                  setPartnerToApprove(partner);
                                  setIsPartnerApproveDialogOpen(true);
                                }}
                                className="bg-green-600 text-white hover:bg-green-700 rounded-xl"
                              >
                                <CheckCircle2 className="w-4 h-4 mr-2" />
                                Approve Member
                              </Button>
                            )}


                          {canDelete && (
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => {
                                setPartnerToRemove(partner);
                                setIsPartnerRemoveDialogOpen(true);
                              }}
                              className="text-red-600 hover:text-red-700 hover:bg-red-50 border-red-200 rounded-xl"
                            >
                              <Trash2 className="w-4 h-4 mr-2" />
                              Remove Member
                            </Button>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Editable Member Information */}
                    {canEdit && (
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div className="space-y-2">
                          <InputFieldset
                            label="ITS Number"
                            id="partnerItsNumber"
                            value={partner?.itsNumber}
                            readOnly
                            disabled
                            tabIndex={-1}
                            className="!bg-gray-100 cursor-not-allowed font-mono [&_legend]:!bg-gray-100"
                          />
                        </div>

                        <div className="space-y-2">
                          <InputFieldset
                            label="Full Name"
                            // required
                            readOnly
                            id={`partner-${partner.id}-fullName`}
                            value={partner.fullName}
                            onChange={(e) => {
                              const value = removeFullSpecialCharacters(
                                e.target.value,
                              );
                              setPartners(
                                partners.map((p) =>
                                  p.id === partner.id
                                    ? { ...p, fullName: value }
                                    : p,
                                ),
                              );
                            }}
                            placeholder="Enter full name"
                            className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                            disabled={activeTab !== "pending"}
                          />
                        </div>

                        <div className="space-y-2">
                          <InputFieldset
                            label="Email"
                            // required
                            readOnly
                            id={`partner-${partner.id}-email`}
                            type="email"
                            value={partner.email}
                            onChange={(e) => {
                              setPartners(
                                partners.map((p) =>
                                  p.id === partner.id
                                    ? { ...p, email: e.target.value }
                                    : p,
                                ),
                              );
                            }}
                            placeholder="Enter email"
                            className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                            disabled={activeTab !== "pending"}
                          />
                        </div>

                        <div className="space-y-2">
                          <InputFieldset
                            label="Mobile Number"
                            // required
                            readOnly
                            id={`partner-${partner.id}-mobile`}
                            value={partner.mobileNumber}
                            onChange={(e) => {
                              setPartners(
                                partners.map((p) =>
                                  p.id === partner.id
                                    ? { ...p, mobileNumber: e.target.value }
                                    : p,
                                ),
                              );
                            }}
                            placeholder="+XXX-XXX-XXXXXXX"
                            className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                            disabled={activeTab !== "pending"}
                          />
                        </div>
                      </div>
                    )}

                    {/* Member Role Radio Buttons */}
                    <div className="cursor-not-allowd flex items-center gap-6 pt-3 border-t border-gray-200">
                      <Label className="text-gray-900">
                        Member Type <span className="text-red-500">*</span>
                      </Label>
                      <div className="flex items-center space-x-4">
                        <div className="flex items-center space-x-2">
                          <input
                            type="radio"
                            id={`partner-${partner.id}-isPartner`}
                            name={`partner-${partner.id}-role`}
                            checked={partner.isPartner}
                            onChange={() => {
                              setPartners(
                                partners.map((p) =>
                                  p.id === partner.id
                                    ? {
                                        ...p,
                                        isPartner: true,
                                        isOfficeStaff: false,
                                      }
                                    : p,
                                ),
                              );
                            }}
                            disabled
                            className="cursor-not-allowed w-4 h-4 text-[#5B9BD5] focus:ring-[#5B9BD5]"
                          />
                          <label
                            htmlFor={`partner-${partner.id}-isPartner`}
                            className="cursor-not-allowed text-sm text-gray-900"
                          >
                            Is Partner
                          </label>
                        </div>

                        <div className="flex items-center space-x-2">
                          <input
                            type="radio"
                            id={`partner-${partner.id}-isOfficeStaff`}
                            name={`partner-${partner.id}-role`}
                            checked={partner.isOfficeStaff}
                            onChange={() => {
                              setPartners(
                                partners.map((p) =>
                                  p.id === partner.id
                                    ? {
                                        ...p,
                                        isPartner: false,
                                        isOfficeStaff: true,
                                      }
                                    : p,
                                ),
                              );
                            }}
                            disabled
                            className="cursor-not-allowed w-4 h-4 text-[#5B9BD5] focus:ring-[#5B9BD5]"
                          />
                          <label
                            htmlFor={`partner-${partner.id}-isOfficeStaff`}
                            className="cursor-not-allowed text-sm text-gray-900"
                          >
                            Office Staff
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Additional Member Options */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 pt-3 border-t border-gray-200">
                      <div className="flex items-center space-x-2">
                        <Checkbox
                          id={`partner-${partner.id}-loginRequired`}
                          checked={partner.loginRequired}
                          className="disabled:cursor-not-allowed"
                          // checked={partner.loginRequired || selectedRegistration?.loginRequired}
                          onCheckedChange={(checked) => {
                            setPartners(
                              partners.map((p) =>
                                p.id === partner.id
                                  ? { ...p, loginRequired: !!checked }
                                  : p,
                              ),
                            );
                          }}
                          // disabled={activeTab !== 'pending'}
                          disabled={true}
                        />
                        <label
                          htmlFor={`partner-${partner.id}-loginRequired`}
                          className="cursor-not-allowed text-sm text-gray-900"
                        >
                          Login Required
                        </label>
                      </div>

                      <div className="flex items-center space-x-2">
                        <Checkbox
                          id={`partner-${partner.id}-isAGL`}
                          checked={partner.isAuthorizedGroupLeader}
                          className="disabled:cursor-not-allowed"
                          // checked={partner.isAuthorizedGroupLeader || selectedRegistration?.isAuthorizedGroupLeader}
                          onCheckedChange={(checked) => {
                            setPartners(
                              partners.map((p) =>
                                p.id === partner.id
                                  ? { ...p, isAuthorizedGroupLeader: !!checked }
                                  : p,
                              ),
                            );
                          }}
                          // disabled={activeTab !== 'pending'}
                          disabled={true}
                        />
                        <label
                          htmlFor={`partner-${partner.id}-isAGL`}
                          className="cursor-not-allowed text-sm text-gray-900"
                        >
                          Authorized Group Leader
                        </label>
                      </div>
                    </div>

                    {/* Member Documents */}
                    {partner.isPartner && !partner.isOfficeStaff && (
                      <div className="space-y-3 pt-3 border-t border-gray-200">
                        <h4 className="text-gray-900">Member Documents</h4>
                        <div className="space-y-3">
                          {partner?.documents?.length > 0 &&
                            partner?.documents?.map((doc, docIndex) => {
                              return (
                                <div
                                  key={doc.id}
                                  className="border border-gray-200 rounded-lg overflow-hidden"
                                >
                                  {/* Document Row */}
                                  <div className="bg-white hover:bg-gray-50 transition-colors p-3">
                                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                      <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 text-gray-900 flex-shrink-0">
                                        {docIndex + 1}
                                      </span>
                                      <div className="flex-1 min-w-0">
                                        <p className="text-gray-900 text-sm break-words">
                                          {doc.name}
                                          {doc.isRequired && (
                                            <span className="text-red-500 ml-1">
                                              *
                                            </span>
                                          )}
                                        </p>
                                        <p className="text-xs text-red-400">
                                          {`Accepted format: ${doc.acceptedFormats} (Max ${formatFileSizeFromKB(
                                            doc.maxFileSizeKB,
                                          )})`}
                                        </p>
                                      </div>
                                      <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
                                        {doc?.uploadedUrl &&
                                        doc.status !== "REJECTED" ? (
                                          <>
                                            <CheckCircle2 className="w-4 h-4 text-green-600" />
                                            <span className="text-xs text-gray-700">
                                              Uploaded
                                            </span>
                                            <button
                                              className="hover:bg-gray-100 rounded-lg p-1 transition-colors"
                                              style={{ color: "#5B9BD5" }}
                                            >
                                              <Eye
                                                className="w-4 h-4 cursor-pointer"
                                                onClick={() => {
                                                  const fullUrl =
                                                    getFileViewUrl(
                                                      doc.uploadedUrl,
                                                    );
                                                  window.open(
                                                    fullUrl,
                                                    "_blank",
                                                  );
                                                }}
                                              />
                                            </button>
                                          </>
                                        ) : (
                                          <span className="text-xs text-gray-500">
                                            Not uploaded
                                          </span>
                                        )}
                                        {isSuperAdmin &&
                                          doc?.history &&
                                          doc.history.length > 0 && (
                                            <Button
                                              size="sm"
                                              variant="outline"
                                              onClick={() =>
                                                togglePartnerDocHistory(doc.id)
                                              }
                                              className="text-xs border-gray-300 hover:bg-gray-50 rounded-lg flex items-center gap-1 h-7"
                                            >
                                              <History className="w-3 h-3" />
                                              History ({doc.history.length})
                                              {expandedPartnerDocHistory[
                                                doc.id
                                              ] ? (
                                                <ChevronUp className="w-3 h-3" />
                                              ) : (
                                                <ChevronDown className="w-3 h-3" />
                                              )}
                                            </Button>
                                          )}

                                        {/* Upload and Reject Document Button - Always visible */}
                                        {doc.status !== "REJECTED" &&
                                        doc.uploadedUrl ? (
                                          <Button
                                            size="sm"
                                            variant="ghost"
                                            onClick={() =>
                                              handleDeleteDocument(doc.id)
                                            }
                                            className="text-red-600 hover:text-red-700 hover:bg-red-50 rounded-xl"
                                          >
                                            {canDelete && (
                                              <Trash2 className="w-4 h-4" />
                                            )}
                                          </Button>
                                        ) : (
                                          <Button
                                            size="sm"
                                            onClick={() => {
                                              setRejectedDoc({
                                                ...doc,
                                                isPartner: true,
                                                partnerid: partner.id,
                                              });
                                              setShowUploadDialog(true);
                                            }}
                                            style={{
                                              backgroundColor: "#5B9BD5",
                                            }}
                                            className="text-white text-xs"
                                          >
                                            {canAdd && (
                                              <Upload className="w-3.5 h-3.5 mr-1" />
                                            )}
                                            Upload
                                          </Button>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  {/* Document History - Super Admin Only */}
                                  {isSuperAdmin &&
                                    doc?.history &&
                                    doc.history.length > 0 &&
                                    expandedPartnerDocHistory[doc.id] && (
                                      <div className="bg-gradient-to-r from-blue-50 to-white border-t border-gray-200 p-3">
                                        <h5
                                          className="text-xs mb-2"
                                          style={{ color: "#5B9BD5" }}
                                        >
                                          📋 Upload History (
                                          {doc.history.length} versions)
                                        </h5>
                                        <div className="space-y-2">
                                          {doc.history.map((hist, index) => (
                                            <div
                                              key={hist.id || index}
                                              className={`p-2 rounded-lg border ${
                                                hist.historyStatus.toLowerCase() ===
                                                "approved"
                                                  ? "bg-green-50 border-green-200"
                                                  : hist.historyStatus.toLowerCase() ===
                                                      "rejected"
                                                    ? "bg-red-50 border-red-200"
                                                    : "bg-gray-50 border-gray-200"
                                              }`}
                                            >
                                              <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-2">
                                                <div className="flex-1 w-full sm:w-auto">
                                                  <div className="flex flex-wrap items-center gap-2 mb-1">
                                                    <Badge
                                                      className={`text-xs ${
                                                        hist.historyStatus.toLowerCase() ===
                                                        "approved"
                                                          ? "bg-green-100 text-green-700 border-green-300"
                                                          : hist.historyStatus.toLowerCase() ===
                                                              "rejected"
                                                            ? "bg-red-100 text-red-700 border-red-300"
                                                            : "bg-gray-100 text-gray-700 border-gray-300"
                                                      }`}
                                                    >
                                                      {hist.historyStatus.toUpperCase()}
                                                    </Badge>
                                                    {hist.actionAt && (
                                                      <span className="text-xs text-gray-600">
                                                        Uploaded:{" "}
                                                        {
                                                          formatUploadedDateTime(
                                                            hist.actionAt,
                                                          ).date
                                                        }{" "}
                                                        at{" "}
                                                        {
                                                          formatUploadedDateTime(
                                                            hist.actionAt,
                                                          ).time
                                                        }
                                                      </span>
                                                    )}
                                                  </div>
                                                  {hist.reviewedBy && (
                                                    <span className="text-xs text-gray-600 block mb-1">
                                                      Reviewed by{" "}
                                                      {hist.reviewedBy} on{" "}
                                                      {hist.reviewedDate} at{" "}
                                                      {hist.reviewedTime}
                                                    </span>
                                                  )}
                                                  {hist.remarks && (
                                                    <p className="text-xs text-gray-700 break-words">
                                                      <span className="text-gray-900">
                                                        Remarks:
                                                      </span>{" "}
                                                      {hist.remarks}
                                                    </p>
                                                  )}
                                                </div>
                                                <button
                                                  className="hover:bg-gray-100 rounded-lg p-1 transition-colors flex-shrink-0"
                                                  style={{ color: "#5B9BD5" }}
                                                >
                                                  <Eye
                                                    className="w-3.5 h-3.5 cursor-pointer"
                                                    onClick={() => {
                                                      if (!hist.filePath)
                                                        return;

                                                      const fullUrl =
                                                        getFileViewUrl(
                                                          hist.filePath,
                                                        );
                                                      window.open(
                                                        fullUrl,
                                                        "_blank",
                                                      );
                                                    }}
                                                  />
                                                </button>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
            </CardContent>
          </Card>
        )}

        {/* Admin Configuration - Only for Pending */}
        {activeTab === "pending" && (
          <Card
            className="border-[#5B9BD5]/30 shadow-lg"
            style={{ backgroundColor: "white", marginTop: "10px" }}
          >
            <CardHeader>
              <div className="flex items-center gap-2">
                <Building2 className="w-5 h-5" style={{ color: "#5B9BD5" }} />
                <CardTitle className="text-gray-900">
                  Admin Configuration
                </CardTitle>
              </div>
              <p className="text-sm text-gray-600 mt-1">
                {selectedRegistration &&
                selectedRegistration.partners &&
                selectedRegistration.partners.length > 0
                  ? "Configure venue assignments and permissions individually for each partner"
                  : "Configure venue assignments, permissions, and approval settings"}
              </p>
            </CardHeader>
            <CardContent>
              {/* Show Partner-wise configuration if partners exist */}
              {selectedRegistration &&
              selectedRegistration.partners &&
              selectedRegistration.partners.length > 0 ? (
                <div className="space-y-6">
                  {/* Partner Selection Tabs */}
                  <div className="hidden space-y-3">
                    <Label className="text-gray-900">
                      Select Person to Configure{" "}
                      <span className="text-red-500">*</span>
                    </Label>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      {/* Partner Cards */}
                      {partners
                        .filter((p) => p.role === "OWNER")
                        .map((partner, index) => {
                          const config = partnerConfigurations.find(
                            (c) => c.partnerId === partner.id,
                          );
                          const isConfigured =
                            config && config.permissionDate && config.toType;
                          return (
                            <div
                              key={partner.id || index}
                              onClick={() => {
                                setSelectedPartnerForConfig(partner);
                                // Load existing configuration if available
                                const existingConfig =
                                  partnerConfigurations.find(
                                    (c) => c.partnerId === partner.id,
                                  );
                                if (existingConfig) {
                                  setPermissionDate(
                                    existingConfig.permissionDate ||
                                      String(
                                        selectedPartnerForConfig?.permissionExpireDate,
                                      ),
                                  );
                                  setToType(existingConfig.toType);
                                  setIsInclusive(existingConfig.isInclusive);
                                  setPermanentDiscount(
                                    existingConfig.permanentDiscount,
                                  );
                                  setIsRequiredForPublic(
                                    existingConfig.isRequiredForPublic,
                                  );
                                } else {
                                  // Reset to defaults
                                  setPermissionDate("");
                                  setToType("");
                                  setIsInclusive(false);
                                  setPermanentDiscount("");
                                  setIsRequiredForPublic(false);
                                }
                              }}
                              className={`p-4 rounded-xl border-2 cursor-pointer transition-all ${
                                selectedPartnerForConfig?.id === partner.id
                                  ? "border-[#5B9BD5] bg-white shadow-md"
                                  : "border-gray-200 bg-white hover:border-gray-300"
                              }`}
                            >
                              <div className="flex items-start justify-between mb-2">
                                <div className="flex-1">
                                  <div className="flex items-center gap-2">
                                    {partner.isMainOperator && (
                                      <User className="w-4 h-4 text-[#5B9BD5]" />
                                    )}
                                    <p className="text-gray-900">
                                      {partner?.name}
                                    </p>
                                  </div>
                                  <p className="text-sm text-gray-600 font-mono mt-1">
                                    ITS: {partner.itsNumber}
                                  </p>
                                  {partner.isMainOperator ? (
                                    <Badge
                                      variant="outline"
                                      className="bg-purple-50 text-purple-700 border-purple-200 text-xs px-2 py-0.5 mt-2 w-fit"
                                    >
                                      Main Operator
                                    </Badge>
                                  ) : (
                                    <Badge
                                      variant="outline"
                                      className="bg-purple-50 text-purple-700 border-purple-200 text-xs px-2 py-0.5 mt-2 w-fit"
                                    >
                                      {partner.role.toLowerCase()}
                                    </Badge>
                                  )}
                                </div>
                                {isConfigured && (
                                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" />
                                )}
                              </div>
                              {isConfigured && config && (
                                <div className="space-y-1 text-xs">
                                  <p className="text-gray-600">
                                    Expires: {config.permissionDate}
                                  </p>
                                </div>
                              )}
                            </div>
                          );
                        })}
                    </div>
                  </div>

                  {/* Configuration Form for Selected Partner */}
                  {selectedPartnerForConfig &&
                    selectedPartnerForConfig.role === "OWNER" && (
                      <div
                        className="mt-0 p-6 rounded-lg border-2 space-y-6"
                        style={{
                          borderColor: "#5B9BD5",
                          backgroundColor: "white",
                        }}
                      >
                        <div className="flex items-center justify-between pb-4 border-b border-gray-200">
                          <div>
                            <h3 className="text-gray-900">
                              {/* Configu: {selectedPartnerForConfig?.name} */}
                              Owner: {selectedPartnerForConfig?.name}
                            </h3>
                            <p className="text-sm text-gray-600 mt-1">
                              Set permissions and access for this partner
                              {/* Set individual permissions and access for this partner */}
                            </p>
                          </div>
                          <Button
                            onClick={() => handleSaveConfiguration()}
                            className="text-white shadow-lg hover:opacity-90 transition-opacity rounded-xl"
                            style={{ backgroundColor: "#5B9BD5" }}
                          >
                            <Check className="w-4 h-4 mr-2" />
                            Save Configuration
                          </Button>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                          {/* Permission Date */}
                          <div className="space-y-2">
                            <InputFieldset
                              label="Permission Expiry Date"
                              required
                              id="permissionDate"
                              type="date"
                              min={minimumPermissionDate}
                              value={permissionDate}
                              onChange={(e) =>
                                handlePermissionDateChange(e.target.value)
                              }
                              aria-invalid={Boolean(
                                configErrors.permissionDate,
                              )}
                              className="bg-white border-gray-300 rounded-lg"
                            />
                            <p className="text-xs text-gray-600">
                              Set expiry date for tour operator account access.{" "}
                              <span className="font-medium text-sky-700">
                                Past dates are disabled.
                              </span>
                            </p>
                            {configErrors.permissionDate && (
                              <p className="text-xs text-red-600">
                                {configErrors.permissionDate}
                              </p>
                            )}
                          </div>

                          {/* Tour Operator Type */}
                          <div className="space-y-2">
                            <SelectFieldset label="Tour Operator Type" required>
                              <Select value={toType} onValueChange={setToType}>
                                <SelectTriggerUI
                                  id="toType"
                                  className="bg-input-background bg-white border-gray-300 rounded-xl"
                                >
                                  <SelectValue placeholder="Select TO type" />
                                </SelectTriggerUI>
                                <SelectContent>
                                  {TourOperatorList &&
                                    TourOperatorList?.map((type) => (
                                      <SelectItem
                                        key={type.tourOperatorTypeId}
                                        value={String(type.tourOperatorTypeId)}
                                        className={!type.isActive ? "text-red-600" : ""}
                                      >
                                        {type.typeName}
                                        {!type?.isActive && "  (Inactive)"}
                                      </SelectItem>
                                    ))}
                                </SelectContent>
                              </Select>
                            </SelectFieldset>
                            <p className="text-xs text-gray-600">
                              Defines operator category and permissions
                            </p>
                            {configErrors.toType && (
                              <p className="text-xs text-red-600">
                                {configErrors.toType}
                              </p>
                            )}
                          </div>

                          {/* Permanent Discount (shown when inclusive is enabled) */}
                          {isInclusive && (
                            <div className="space-y-2">
                              <InputFieldset
                                label="Permanent Discount (%)"
                                id="permanentDiscount"
                                type="number"
                                min="0"
                                max="100"
                                value={permanentDiscount}
                                onChange={(e) =>
                                  setPermanentDiscount(e.target.value)
                                }
                                placeholder="e.g., 10"
                                className="h-11 bg-white border-gray-300 rounded-xl"
                              />
                              <p className="text-xs text-gray-600">
                                Discount applies to transport
                              </p>
                              {configErrors.permanentDiscount && (
                                <p className="text-xs text-red-600">
                                  {configErrors.permanentDiscount}
                                </p>
                              )}
                            </div>
                          )}

                          {/* Toggles */}
                          <div className="space-y-4 lg:col-span-3">
                            <div className="flex items-start space-x-3 p-4 bg-white rounded-xl border border-gray-200">
                              <Checkbox
                                id="isInclusive"
                                checked={
                                  isInclusive ||
                                  selectedPartnerForConfig.isInclusive
                                }
                                onCheckedChange={(checked) => {
                                  setIsInclusive(!!checked);
                                  if (!checked) setPermanentDiscount("");
                                }}
                              />
                              <div className="flex-1">
                                <label
                                  htmlFor="isInclusive"
                                  className="text-sm text-gray-900 cursor-pointer block"
                                >
                                  Is Inclusive
                                </label>
                                <p className="text-xs text-gray-600 mt-1">
                                  Enable to provide discount on transport
                                  services. When enabled, you can set permanent
                                  discount percentage.
                                </p>
                              </div>
                            </div>

                            <div className="flex items-start space-x-3 p-4 bg-white rounded-xl border border-gray-200">
                              <Checkbox
                                id="isRequiredForPublic"
                                checked={
                                  isRequiredForPublic ||
                                  selectedPartnerForConfig?.isPublic
                                }
                                onCheckedChange={(checked) =>
                                  setIsRequiredForPublic(!!checked)
                                }
                              />
                              <div className="flex-1">
                                <label
                                  htmlFor="isRequiredForPublic"
                                  className="text-sm text-gray-900 cursor-pointer block"
                                >
                                  Is Required for Public
                                </label>
                                <p className="text-xs text-gray-600 mt-1">
                                  Enable to display operator details in public
                                  webpage directory
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                  {/* Summary of All Configurations */}
                  {partnerConfigurations.length > 0 && (
                    <Alert className="border-green-200 bg-green-50 mt-4">
                      <CheckCircle2 className="w-4 h-4 text-green-600" />
                      <div className="flex items-center gap-2 whitespace-nowrap">
                        <AlertDescription className="text-green-800 flex items-center gap-1">
                          <span>
                            <strong>{partnerConfigurations.length}</strong> of{" "}
                            {selectedRegistration?.partners?.length || 0}{" "}
                            {(selectedRegistration?.partners?.length || 0) === 1
                              ? "person"
                              : "persons"}{" "}
                            configured (
                            {selectedRegistration?.partners?.filter(
                              (p) => p.isMainOperator,
                            ).length || 0}{" "}
                            Main Operator +{" "}
                            {selectedRegistration?.partners?.filter(
                              (p) => !p.isMainOperator,
                            ).length || 0}{" "}
                            Partner
                            {(selectedRegistration?.partners?.filter(
                              (p) => !p.isMainOperator,
                            ).length || 0) === 1
                              ? ""
                              : "s"}
                            )
                          </span>
                        </AlertDescription>
                      </div>
                    </Alert>
                  )}
                </div>
              ) : (
                // Original configuration for TO without partners
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {/* Permission Date */}
                    <div className="space-y-2">
                      <InputFieldset
                        label="Permission Expiry Date"
                        required
                        id="permissionDate"
                        type="date"
                        min={minimumPermissionDate}
                        value={permissionDate}
                        onChange={(e) =>
                          handlePermissionDateChange(e.target.value)
                        }
                        aria-invalid={Boolean(configErrors.permissionDate)}
                        className="bg-white border-gray-300 rounded-lg"
                      />
                      <p className="text-xs text-gray-600">
                        Set expiry date for tour operator account access.{" "}
                        <span className="font-medium text-sky-700">
                          Past dates are disabled.
                        </span>
                      </p>
                      {configErrors.permissionDate && (
                        <p className="text-xs text-red-600">
                          {configErrors.permissionDate}
                        </p>
                      )}
                    </div>

                    {/* Tour Operator Type */}
                    <div className="space-y-2">
                      <SelectFieldset label="Tour Operator Type" required>
                        <Select value={toType} onValueChange={setToType}>
                          <SelectTriggerUI
                            id="toType"
                            className="bg-white border-gray-300 rounded-lg"
                          >
                            <SelectValue placeholder="Select TO type" />
                          </SelectTriggerUI>
                          <SelectContent>
                            {TourOperatorList &&
                              TourOperatorList?.map((type) => (
                                <SelectItem
                                  key={type.tourOperatorTypeId}
                                  value={type.tourOperatorTypeId}
                                >
                                  {type.typeName}
                                </SelectItem>
                              ))}
                          </SelectContent>
                        </Select>
                      </SelectFieldset>
                      <p className="text-xs text-gray-600">
                        Defines operator category and permissions
                      </p>
                    </div>

                    {/* Permanent Discount */}
                    {isInclusive && (
                      <div className="space-y-2">
                        <InputFieldset
                          label="Permanent Discount (%)"
                          id="permanentDiscount"
                          type="number"
                          min="0"
                          max="100"
                          value={permanentDiscount}
                          onChange={(e) => setPermanentDiscount(e.target.value)}
                          placeholder="e.g., 10"
                          className="h-11 bg-white border-gray-300 rounded-xl"
                        />
                        <p className="text-xs text-gray-600">
                          Discount applies to transport
                        </p>
                      </div>
                    )}

                    {/* Toggles */}
                    <div className="space-y-4 lg:col-span-3">
                      <div className="flex items-start space-x-3 p-4 bg-white rounded-xl border border-gray-200">
                        <Checkbox
                          id="isInclusive"
                          checked={isInclusive}
                          onCheckedChange={(checked) => {
                            setIsInclusive(!!checked);
                            if (!checked) setPermanentDiscount("");
                          }}
                        />
                        <div className="flex-1">
                          <label
                            htmlFor="isInclusive"
                            className="text-sm text-gray-900 cursor-pointer block"
                          >
                            Is Inclusive
                          </label>
                          <p className="text-xs text-gray-600 mt-1">
                            Enable to provide discount on transport services
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start space-x-3 p-4 bg-white rounded-xl border border-gray-200">
                        <Checkbox
                          id="isRequiredForPublic"
                          checked={isRequiredForPublic}
                          onCheckedChange={(checked) =>
                            setIsRequiredForPublic(!!checked)
                          }
                        />
                        <div className="flex-1">
                          <label
                            htmlFor="isRequiredForPublic"
                            className="text-sm text-gray-900 cursor-pointer block"
                          >
                            Is Required for Public
                          </label>
                          <p className="text-xs text-gray-600 mt-1">
                            Enable to display operator details in public webpage
                            directory
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Misal Mubarak Upload - Common for both partner and non-partner scenarios */}
              {canAdd && (
                <div className="space-y-2 mt-6 pt-6 border-t border-gray-200">
                  <Label htmlFor="misalMubarak" className="text-gray-900">
                    Upload Misal Mubarak (Approval Document){" "}
                    <span className="text-red-500">*</span>
                  </Label>
                  {misaldocuments.map((doc, index) => (
                    <div className="flex items-center gap-4" key={index}>
                      <input
                        type="file"
                        id={`file-${doc.id}`}
                        accept={doc.acceptedFormatsList
                          .map((ext) => `.${ext}`)
                          .join(",")}
                        onChange={(e) =>
                          handleMisalFileUpload(
                            doc.id,
                            e.target.files?.[0] || null,
                          )
                        }
                        className="hidden"
                      />
                      <Button
                        type="button"
                        onClick={() =>
                          document.getElementById(`file-${doc.id}`)?.click()
                        }
                        variant="outline"
                        className="border-2 rounded-xl"
                        style={{ borderColor: "#5B9BD5", color: "#5B9BD5" }}
                      >
                        <Upload className="w-4 h-4 mr-2" />
                        {doc.file ? "Change File" : "Choose File"}
                      </Button>
                      {
                        <div className="flex items-center gap-2 text-sm text-green-600">
                          {doc.file && <CheckCircle2 className="w-4 h-4" />}
                          <span className="max-w-md truncate">
                            {doc.file ? doc.file.name : doc.name}
                            {doc.isRequired && (
                              <span className="text-destructive ml-1">*</span>
                            )}
                          </span>
                        </div>
                      }

                      {isSuperAdmin && showMisalHistory.length > 0 && (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() =>
                            setExpandedMisalHistory(!expandedMisalHistory)
                          }
                          className="text-sm border-gray-300 hover:bg-gray-50 rounded-xl flex items-center gap-1"
                        >
                          <History className="w-3 h-3" />
                          View Upload History (
                          {showMisalHistory[index]?.history?.length})
                          {expandedMisalHistory ? (
                            <ChevronUp className="w-3 h-3" />
                          ) : (
                            <ChevronDown className="w-3 h-3" />
                          )}
                        </Button>
                      )}
                    </div>
                  ))}

                  {canAdd && (
                    <p className="text-xs text-gray-600">
                      Admin must upload Misal Mubarak before approval. Accepted
                      format: PDF (Max 5MB)
                    </p>
                  )}

                  {/* Misal Mubarak History - Super Admin Only */}
                  {isSuperAdmin &&
                    expandedMisalHistory &&
                    showMisalHistory.length > 0 && (
                      <div className="mt-4 p-4 bg-gradient-to-r from-blue-50 to-white border border-blue-200 rounded-lg">
                        {showMisalHistory.map((doc) => (
                          <div key={doc.id} className="mb-4">
                            <h4
                              className="text-sm mb-3"
                              style={{ color: "#5B9BD5" }}
                            >
                              📋 Misal Mubarak Upload History (
                              {doc.history?.length || 0} versions)
                            </h4>

                            <div className="space-y-2">
                              {doc.history?.map((hist, index) => (
                                <div
                                  key={hist.approvalHistoryId || index}
                                  className={`p-3 rounded-lg border ${
                                    hist.historyStatus.toLowerCase() ===
                                    "APPROVED"
                                      ? "bg-green-50 border-green-200"
                                      : hist.historyStatus.toLowerCase() ===
                                          "REJECTED"
                                        ? "bg-red-50 border-red-200"
                                        : "bg-gray-50 border-gray-200"
                                  }`}
                                >
                                  <div className="flex items-start justify-between gap-3">
                                    <div className="flex-1">
                                      <Badge
                                        className={`text-xs ${
                                          hist.historyStatus.toLowerCase() ===
                                          "APPROVED"
                                            ? "bg-green-100 text-green-700 border-green-300"
                                            : hist.historyStatus.toLowerCase() ===
                                                "REJECTED"
                                              ? "bg-red-100 text-red-700 border-red-300"
                                              : "bg-gray-100 text-gray-700 border-gray-300"
                                        }`}
                                      >
                                        {hist.historyStatus}
                                      </Badge>

                                      <p className="text-xs text-gray-600 mt-1">
                                        Uploaded: {hist.actionAt}
                                      </p>

                                      {hist.remarks && (
                                        <p className="text-xs text-gray-700 mt-1">
                                          <span className="text-gray-900">
                                            Remarks:
                                          </span>{" "}
                                          {hist.remarks}
                                        </p>
                                      )}
                                    </div>
                                    {doc.versions &&
                                      doc.versions.length > 0 && (
                                        <button
                                          className="hover:bg-gray-100 rounded-lg p-1 transition-colors flex-shrink-0"
                                          style={{ color: "#5B9BD5" }}
                                          onClick={() => {
                                            const version = doc?.versions?.find(
                                              (v) =>
                                                v.documentVersionId ===
                                                hist.documentVersionId,
                                            );

                                            if (!version?.filePath) return;

                                            const fullUrl = getFileViewUrl(
                                              version.filePath,
                                            );
                                            window.open(fullUrl, "_blank");
                                          }}
                                        >
                                          <Eye className="w-4 h-4 cursor-pointer" />
                                        </button>
                                      )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              )}
            </CardContent>
          </Card>
        )}

        {/* Action Buttons - Only for Pending */}
        {activeTab === "pending" &&
          selectedRegistration?.status?.toLowerCase() !== "approved" && (
            <Card
              className="border-[#5B9BD5]/20 bg-white shadow-lg"
              style={{ marginTop: "10px" }}
            >
              <CardContent className="pt-6">
                <div className="space-y-4">
                  {/* Reject Section */}
                  <div className="space-y-2">
                    <SelectFieldset label="Remarks">
                      <TextareaUI
                        id="rejectReason"
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                        placeholder="Please provide detailed reason for rejection..."
                        className="min-h-[100px] bg-white border-gray-300 rounded-xl resize-none"
                      />
                    </SelectFieldset>
                  </div>

                  {/* Action Buttons */}

                  <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-3 sm:gap-4 pt-4">
                    {canDelete && (
                      <Button
                        disabled={isUploading}
                        onClick={handleReject}
                        variant="outline"
                        className="px-8 border-2 border-red-500 text-red-600 hover:bg-red-50 rounded-xl w-full sm:w-auto"
                      >
                        <XCircle className="w-4 h-4 mr-2" />
                        Reject Registration
                      </Button>
                    )}
                    {canApprove && (
                      <Button
                        disabled={isUploading}
                        onClick={() => setShowApproveConfirm(true)} // 🔥 open popup
                        className="px-12 text-white shadow-lg hover:opacity-90 transition-opacity rounded-xl w-full sm:w-auto"
                        style={{ backgroundColor: "#5B9BD5" }}
                      >
                        <CheckCircle2 className="w-4 h-4 mr-2" />
                        Approve Registration
                      </Button>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          )}

        {/* Rejection Reason Display - Only for Rejected */}
        {activeTab === "rejected" && selectedRegistration?.rejectedReason && (
          <Alert className="border-red-200 bg-red-50">
            <AlertCircle className="w-4 h-4 text-red-600" />
            <AlertDescription className="text-red-800">
              <strong>Rejection Reason:</strong>{" "}
              {selectedRegistration.rejectedReason}
            </AlertDescription>
          </Alert>
        )}

        {/* Delete Document Confirmation Dialog */}
        <Dialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
          <DialogContent className="sm:max-w-[500px]">
            <DialogHeader>
              <DialogTitle style={{ color: "#5B9BD5" }}>
                Remove Document
              </DialogTitle>
              <DialogDescription>
                Please provide a reason for removing this document. The
                applicant will be notified to upload a revised document.
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label htmlFor="deleteRemark" className="text-gray-900">
                  Reason for Document Revision{" "}
                  <span className="text-red-500">*</span>
                </Label>
                <Textarea
                  id="deleteRemark"
                  value={deleteRemark}
                  onChange={(e) => setDeleteRemark(e.target.value)}
                  placeholder="e.g., Document is not clear, incorrect document uploaded, signature missing..."
                  className="min-h-[120px] bg-white border-gray-300 rounded-xl resize-none"
                />
              </div>
            </div>
            <DialogFooter>
              <Button
                variant="outline"
                onClick={() => {
                  setIsDeleteDialogOpen(false);
                  setDocumentToDelete(null);
                  setDeleteRemark("");
                }}
                className="rounded-xl"
              >
                Cancel
              </Button>
              <Button
                onClick={confirmDeleteDocument}
                disabled={isUploading}
                style={{ backgroundColor: "#5B9BD5" }}
                className="text-white rounded-xl"
              >
                {isUploading ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    loading...
                  </>
                ) : (
                  <>
                    <Trash2 className="w-4 h-4 mr-2" />
                    Remove Document
                  </>
                )}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* REMOVE PARTNER CONFIRMATION DIALOG COMPONENT */}
        <ConfirmDialog
          open={isPartnerRemoveDialogOpen}
          onOpenChange={setIsPartnerRemoveDialogOpen}
          title="Remove Member"
          description="Are you sure you want to remove this member from the registration?"
          confirmText="Remove"
          cancelText="Cancel"
          loading={isDeleting}
          onConfirm={handleConfirmRemovePartner}
        >
          {/* children render inside box */}
          {partnerToRemove && (
            <div className="py-2">
              <div className="p-4 rounded-lg border-2 border-gray-200 bg-gray-50 space-y-2">
                <div className="flex items-center gap-2">
                  <User className="w-4 h-4 text-gray-600" />
                  <p className="text-gray-900">{partnerToRemove.fullName}</p>
                </div>

                <p className="text-sm text-gray-600">
                  ITS Number: {partnerToRemove.itsNumber}
                </p>

                <p className="text-sm text-gray-600">
                  Email: {partnerToRemove.email}
                </p>
              </div>
            </div>
          )}
          {/* children render inside box */}
        </ConfirmDialog>

        {/* APPROVE PARTNER CONFIRMATION DIALOG COMPONENT */}
        <ConfirmDialog
          open={isPartnerApproveDialogOpen}
          onOpenChange={setIsPartnerApproveDialogOpen}
          title="Approve Member"
          description="Are you sure you want to approve this member?"
          confirmText="Approve Member"
          cancelText="Cancel"
          confirmVariant="success"
          loading={isApprovingMember}
          show={false}
          onConfirm={handleConfirmApprovePartner}
          onCancel={() => setPartnerToApprove(null)}
        >
          {partnerToApprove && (
            <div className="py-2">
              <div className="p-4 rounded-lg border-2 border-green-200 bg-green-50 space-y-2">
                <div className="flex items-center gap-2">
                  <User className="w-4 h-4 text-green-700" />
                  <p className="text-gray-900">{partnerToApprove.fullName}</p>
                </div>
                <p className="text-sm text-gray-600">
                  ITS Number: {partnerToApprove.itsNumber}
                </p>
                <p className="text-sm text-gray-600">
                  Email: {partnerToApprove.email}
                </p>
              </div>
            </div>
          )}
        </ConfirmDialog>
      </div>

      {/* ADD PARTNER POPUP  */}
      {isPartnerDialogOpen && (
        <AddNewPartnerPopup
          isPartnerDialogOpen={isPartnerDialogOpen}
          setIsPartnerDialogOpen={setIsPartnerDialogOpen}
          partnerFormData={partnerFormData}
          setPartnerFormData={setPartnerFormData}
          handlePartnerFileUpload={handlePartnerFileUpload}
          handleSavePartner={handleSavePartner}
          AddpartnerErrors={AddpartnerErrors}
          setAddPartnerErrors={setAddPartnerErrors}
          isSoleProprietor={isSoleProprietor}
          // selectedRegistration={selectedRegistration}
        />
      )}
      {/* ADD PARTNER POPUP */}

      {/*RE-UPLOAD NEW DOCUMENT START POPUP*/}
      {showUploadDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <Card className="bg-white shadow-lg rounded-2xl w-[500px]">
            <CardContent className="p-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">
                Upload Documents
              </h2>
              <div className="space-y-4">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                  <Upload className="w-8 h-8 text-gray-400 mx-auto mb-3" />
                  <Input
                    ref={fileInputRef}
                    type="file"
                    // multiple
                    accept=".pdf,.jpg,.jpeg,.png"
                    className="hidden"
                    onChange={(e) => {
                      const files = Array.from(e.target.files || []);
                      setReuploadFiles(files);
                    }}
                  />
                  <p className="text-sm text-gray-600 mt-2 mb-2">
                    {reUploadFiles.length > 0
                      ? `${reUploadFiles.length} file(s) selected`
                      : "No files selected"}
                  </p>
                  <div className="flex justify-center">
                    <Label htmlFor="batch-upload">
                      <Button
                        variant="outline"
                        onClick={() => fileInputRef.current?.click()}
                      >
                        Select Files
                      </Button>
                    </Label>
                  </div>
                </div>
                <div className="bg-amber-50 border-2 border-amber-200 rounded-lg p-3">
                  <p className="text-xs text-amber-800">Upload documents</p>
                </div>
              </div>
              <div className="flex items-center justify-end gap-3 mt-6">
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowUploadDialog(false);
                    setRejectedDoc(null);
                    setReuploadFiles([]);
                  }}
                  className="text-gray-900 hover:bg-gray-100"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleNewConfirmUpload}
                  disabled={isUploading}
                  style={{ backgroundColor: "#5B9BD5" }}
                  className="text-white hover:opacity-90 px-6 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isUploading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Uploading...
                    </>
                  ) : (
                    <>
                      <Upload className="w-4 h-4 mr-2" />
                      Confirm Upload
                    </>
                  )}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
      {/* UPLOAD NEW DOCUMENT END */}

      {/* CONFIRMATION POPUP BEFORE APPROVAL*/}
      <Dialog open={showApproveConfirm} onOpenChange={setShowApproveConfirm}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Confirm Approval</DialogTitle>
            <DialogDescription>
              Are you sure you want to approve this registration?
            </DialogDescription>
          </DialogHeader>

          <div className="flex justify-end gap-2 mt-4">
            <Button
              variant="outline"
              onClick={() => setShowApproveConfirm(false)}
            >
              Cancel
            </Button>

            <Button
              onClick={async () => {
                setShowApproveConfirm(false);
                await handleApproved(); // call original function
              }}
              className="bg-green-600 text-white"
            >
              Yes, Approve
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
